<template>
  <div id="OneSVG">
    <svg
      version="1.1"
      id="图层_X"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="90%"
      height="100%"
      viewBox="0 0 4077.409912109375 2493.25"
      enable-background="new 0 0 4077.41 2493.25"
      xml:space="preserve"
      preserveAspectRatio="xMidYMid meet"
      style="background-color: #fff;margin-left: 5%;"
    >
      <g id="图层_1">
        <line
          style="fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
          x1="768.621"
          y1="746.653"
          x2="768.621"
          y2="1051.32"
        />
        <line
          style="fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
          x1="768.621"
          y1="358.32"
          x2="768.621"
          y2="573.32"
        />
        <g>
          <defs>
            <rect id="SVGID_1_" y="0.004" width="4077.408" height="2573.926" />
          </defs>
          <clipPath id="SVGID_2_">
            <use xlink:href="#SVGID_1_" style="overflow:visible;" />
          </clipPath>
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M755.121,1005.32h27l-14-14C768.121,991.32,758.121,1005.32,755.121,1005.32"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2387.121,601.32h27l-14-14C2400.121,587.32,2390.121,601.32,2387.121,601.32"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M3287.505,601.32h27l-14-14C3300.505,587.32,3290.505,601.32,3287.505,601.32"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			765.754,847.32 659.754,847.32 659.754,879.82 		"
          />
          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="647.083"
            y1="881.07"
            x2="672.083"
            y2="881.07"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="647.083"
            y1="893.07"
            x2="672.083"
            y2="893.07"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="659.583"
            cy="922.82"
            r="14.5"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="659.583"
            y1="894.07"
            x2="659.583"
            y2="906.57"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="659.583"
            y1="939.07"
            x2="659.583"
            y2="949.82"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="648.583,950.07 670.583,950.07 666.833,955.57 651.583,955.57 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="652.958,959.82 666.208,959.82 664.458,964.07 655.708,964.07 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="657.083,967.57 662.083,967.57 659.667,971.07 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="649.583"
            y1="912.736"
            x2="669.583"
            y2="930.819"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="650.542"
            y1="931.945"
            x2="668.625"
            y2="911.945"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1952.584"
            y1="839.07"
            x2="1977.584"
            y2="839.07"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1952.584"
            y1="851.07"
            x2="1977.584"
            y2="851.07"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1965.084"
            cy="880.82"
            r="14.5"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1965.084"
            y1="852.07"
            x2="1965.084"
            y2="864.57"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1965.084,897.07 1965.084,918.82 2036.505,918.82 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1955.084"
            y1="870.736"
            x2="1975.084"
            y2="888.819"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1956.042"
            y1="889.945"
            x2="1974.125"
            y2="869.945"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="909.084"
            y1="654.403"
            x2="934.084"
            y2="654.403"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="909.084"
            y1="666.403"
            x2="934.084"
            y2="666.403"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="921.584"
            cy="696.153"
            r="14.5"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="921.584"
            y1="667.403"
            x2="921.584"
            y2="679.903"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="921.584"
            y1="712.403"
            x2="921.584"
            y2="723.153"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="910.584,723.403 932.584,723.403 928.834,728.903 913.584,728.903 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="914.959,733.153 928.209,733.153 926.459,737.403 917.709,737.403 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="919.084,740.903 924.084,740.903 921.667,744.403 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="1217.084,946.903 1239.084,946.903 1235.334,952.403 1220.084,952.403 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="1221.459,956.653 1234.709,956.653 1232.959,960.903 1224.209,960.903 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="1225.584,964.403 1230.584,964.403 1228.167,967.903 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="1626.584,872.903 1648.584,872.903 1644.834,878.403 1629.584,878.403 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="1630.959,882.653 1644.209,882.653 1642.459,886.903 1633.709,886.903 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="1635.084,890.403 1640.084,890.403 1637.667,893.903 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="1809.584,944.903 1831.584,944.903 1827.834,950.403 1812.584,950.403 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="1813.959,954.653 1827.209,954.653 1825.459,958.903 1816.709,958.903 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="1818.084,962.403 1823.084,962.403 1820.667,965.903 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="2026.084,943.903 2048.084,943.903 2044.334,949.403 2029.084,949.403 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="2030.459,953.653 2043.709,953.653 2041.959,957.903 2033.209,957.903 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="2034.584,961.403 2039.584,961.403 2037.167,964.903 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="2493.084,943.903 2515.084,943.903 2511.334,949.403 2496.084,949.403 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="2497.459,953.653 2510.709,953.653 2508.959,957.903 2500.209,957.903 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="2501.584,961.403 2506.584,961.403 2504.166,964.903 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="911.584"
            y1="686.07"
            x2="931.584"
            y2="704.153"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="912.542"
            y1="705.278"
            x2="930.625"
            y2="685.278"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			752.121,597.32 768.121,585.32 785.121,597.32 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			752.121,584.32 768.121,572.32 785.121,584.32 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			785.121,721.986 769.121,732.986 752.121,721.986 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			785.121,734.986 769.121,745.986 752.121,734.986 		"
          />

          <rect
            x="750.287"
            y="642.32"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M777.454,662.486c0,4.326-3.507,7.833-7.833,7.833c-4.327,0-7.834-3.507-7.834-7.833
			c0-4.326,3.507-7.833,7.834-7.833C773.947,654.653,777.454,658.161,777.454,662.486"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M776.482,631.104c0,3.591-2.911,6.503-6.503,6.503c-3.591,0-6.503-2.912-6.503-6.503
			c0-3.592,2.912-6.503,6.503-6.503C773.571,624.601,776.482,627.512,776.482,631.104"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M776.482,692.536c0,3.592-2.911,6.503-6.503,6.503c-3.591,0-6.503-2.911-6.503-6.503
			c0-3.591,2.912-6.503,6.503-6.503C773.571,686.033,776.482,688.945,776.482,692.536"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			757.808,602.32 768.808,595.57 779.433,602.445 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			779.433,719.069 768.433,725.819 757.808,718.944 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="769.979"
            y1="595.57"
            x2="769.823"
            y2="722.32"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1875.621,455.82 1891.621,443.82 1908.621,455.82 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1875.621,442.82 1891.621,430.82 1908.621,442.82 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1908.621,580.486 1892.621,591.486 1875.621,580.486 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1908.621,593.486 1892.621,604.486 1875.621,593.486 		"
          />

          <rect
            x="1873.787"
            y="500.819"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1899.954,520.986c0,4.326-3.507,7.833-7.833,7.833c-4.327,0-7.834-3.507-7.834-7.833
			s3.507-7.833,7.834-7.833C1896.447,513.153,1899.954,516.66,1899.954,520.986"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1899.954,483.32c0,4.326-3.507,7.833-7.833,7.833c-4.327,0-7.834-3.507-7.834-7.833
			c0-4.326,3.507-7.833,7.834-7.833C1896.447,475.487,1899.954,478.994,1899.954,483.32"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1899.954,557.32c0,4.326-3.507,7.833-7.833,7.833c-4.327,0-7.834-3.507-7.834-7.833
			c0-4.326,3.507-7.833,7.834-7.833C1896.447,549.487,1899.954,552.994,1899.954,557.32"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1881.308,460.82 1892.308,454.07 1902.933,460.945 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1902.933,577.569 1891.933,584.319 1881.308,577.444 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1892.121"
            y1="456.32"
            x2="1891.934"
            y2="584.32"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2748.621,455.82 2764.621,443.82 2781.621,455.82 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2748.621,442.82 2764.621,430.82 2781.621,442.82 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2781.621,581.486 2765.621,592.486 2748.621,581.486 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2781.621,593.486 2765.621,604.486 2748.621,593.486 		"
          />

          <rect
            x="2746.787"
            y="500.819"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2772.954,520.986c0,4.326-3.507,7.833-7.833,7.833c-4.327,0-7.834-3.507-7.834-7.833
			s3.507-7.833,7.834-7.833C2769.447,513.153,2772.954,516.66,2772.954,520.986"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2772.954,483.32c0,4.326-3.507,7.833-7.833,7.833c-4.327,0-7.834-3.507-7.834-7.833
			c0-4.326,3.507-7.833,7.834-7.833C2769.447,475.487,2772.954,478.994,2772.954,483.32"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2772.954,557.32c0,4.326-3.507,7.833-7.833,7.833c-4.327,0-7.834-3.507-7.834-7.833
			c0-4.326,3.507-7.833,7.834-7.833C2769.447,549.487,2772.954,552.994,2772.954,557.32"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2754.309,460.82 2765.309,454.07 2775.934,460.945 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2775.934,577.569 2764.934,584.319 2754.309,577.444 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2765.121"
            y1="456.32"
            x2="2764.934"
            y2="584.32"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3881.621,1408.82 3897.621,1396.82 3914.621,1408.82 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3881.621,1395.82 3897.621,1383.82 3914.621,1395.82 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3914.621,1534.486 3898.621,1545.486 3881.621,1534.486 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3914.621,1546.486 3898.621,1557.486 3881.621,1546.486 		"
          />

          <rect
            x="3879.787"
            y="1453.819"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M3905.954,1473.986c0,4.326-3.507,7.833-7.833,7.833s-7.834-3.507-7.834-7.833
			s3.508-7.833,7.834-7.833S3905.954,1469.66,3905.954,1473.986"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M3905.954,1436.319c0,4.326-3.507,7.833-7.833,7.833s-7.834-3.507-7.834-7.833
			c0-4.325,3.508-7.833,7.834-7.833S3905.954,1431.994,3905.954,1436.319"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M3905.954,1510.319c0,4.326-3.507,7.833-7.833,7.833s-7.834-3.507-7.834-7.833
			c0-4.325,3.508-7.833,7.834-7.833S3905.954,1505.994,3905.954,1510.319"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3887.309,1413.82 3898.309,1407.07 3908.934,1413.945 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3908.934,1530.569 3897.934,1537.319 3887.309,1530.444 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="3898.121"
            y1="1409.32"
            x2="3897.934"
            y2="1537.32"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2061.621,1328.82 2077.621,1316.82 2094.621,1328.82 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2061.621,1315.82 2077.621,1303.82 2094.621,1315.82 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2094.621,1454.486 2078.621,1465.486 2061.621,1454.486 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2094.621,1466.486 2078.621,1477.486 2061.621,1466.486 		"
          />

          <rect
            x="2059.787"
            y="1373.819"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2085.954,1393.986c0,4.326-3.507,7.833-7.833,7.833s-7.834-3.507-7.834-7.833
			s3.508-7.833,7.834-7.833S2085.954,1389.66,2085.954,1393.986"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2085.954,1356.319c0,4.326-3.507,7.833-7.833,7.833s-7.834-3.507-7.834-7.833
			c0-4.325,3.508-7.833,7.834-7.833S2085.954,1351.994,2085.954,1356.319"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2085.954,1430.319c0,4.326-3.507,7.833-7.833,7.833s-7.834-3.507-7.834-7.833
			c0-4.325,3.508-7.833,7.834-7.833S2085.954,1425.994,2085.954,1430.319"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2067.309,1333.82 2078.309,1327.07 2088.934,1333.945 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2088.934,1450.569 2077.934,1457.319 2067.309,1450.444 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2078.121"
            y1="1329.32"
            x2="2077.934"
            y2="1457.32"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3212.005,1669.153 3228.005,1657.153 3245.005,1669.153 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3212.005,1656.153 3228.005,1644.153 3245.005,1656.153 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3245.005,1794.819 3229.005,1805.819 3212.005,1794.819 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3245.005,1806.819 3229.005,1817.819 3212.005,1806.819 		"
          />

          <rect
            x="3210.171"
            y="1714.152"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M3236.338,1734.319c0,4.326-3.507,7.833-7.833,7.833s-7.834-3.507-7.834-7.833
			c0-4.325,3.508-7.833,7.834-7.833S3236.338,1729.994,3236.338,1734.319"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M3236.338,1696.653c0,4.326-3.507,7.833-7.833,7.833s-7.834-3.507-7.834-7.833
			s3.508-7.833,7.834-7.833S3236.338,1692.327,3236.338,1696.653"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M3236.338,1770.653c0,4.326-3.507,7.833-7.833,7.833s-7.834-3.507-7.834-7.833
			s3.508-7.833,7.834-7.833S3236.338,1766.327,3236.338,1770.653"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3217.692,1674.153 3228.692,1667.403 3239.317,1674.278 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3239.317,1790.903 3228.317,1797.653 3217.692,1790.778 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="3228.505"
            y1="1669.653"
            x2="3228.317"
            y2="1797.653"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			110.004,1457.153 126.004,1445.153 143.004,1457.153 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			110.004,1444.153 126.004,1432.153 143.004,1444.153 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			143.004,1582.819 127.004,1593.819 110.004,1582.819 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			143.004,1594.819 127.004,1605.819 110.004,1594.819 		"
          />

          <rect
            x="108.171"
            y="1502.152"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M134.338,1522.32c0,4.325-3.507,7.832-7.833,7.832c-4.327,0-7.834-3.507-7.834-7.832
			c0-4.326,3.507-7.833,7.834-7.833C130.831,1514.487,134.338,1517.994,134.338,1522.32"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M134.338,1484.653c0,4.326-3.507,7.833-7.833,7.833c-4.327,0-7.834-3.507-7.834-7.833
			s3.507-7.833,7.834-7.833C130.831,1476.82,134.338,1480.327,134.338,1484.653"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M134.338,1558.653c0,4.326-3.507,7.833-7.833,7.833c-4.327,0-7.834-3.507-7.834-7.833
			s3.507-7.833,7.834-7.833C130.831,1550.82,134.338,1554.327,134.338,1558.653"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			115.692,1462.153 126.692,1455.403 137.317,1462.278 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			137.317,1578.903 126.317,1585.653 115.692,1578.778 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="126.504"
            y1="1457.653"
            x2="126.317"
            y2="1585.653"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			808.004,1671.319 824.004,1659.319 841.004,1671.319 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			808.004,1658.319 824.004,1646.319 841.004,1658.319 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			841.004,1796.986 825.004,1807.986 808.004,1796.986 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			841.004,1808.986 825.004,1819.986 808.004,1808.986 		"
          />

          <rect
            x="806.171"
            y="1716.319"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M832.338,1736.486c0,4.326-3.507,7.833-7.833,7.833c-4.327,0-7.834-3.507-7.834-7.833
			s3.507-7.833,7.834-7.833C828.831,1728.653,832.338,1732.16,832.338,1736.486"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M832.338,1698.819c0,4.326-3.507,7.833-7.833,7.833c-4.327,0-7.834-3.507-7.834-7.833
			c0-4.325,3.507-7.833,7.834-7.833C828.831,1690.986,832.338,1694.494,832.338,1698.819"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M832.338,1772.819c0,4.326-3.507,7.833-7.833,7.833c-4.327,0-7.834-3.507-7.834-7.833
			c0-4.325,3.507-7.833,7.834-7.833C828.831,1764.986,832.338,1768.494,832.338,1772.819"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			813.692,1676.319 824.692,1669.569 835.317,1676.444 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			835.317,1793.069 824.317,1799.819 813.692,1792.944 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="824.504"
            y1="1671.819"
            x2="824.317"
            y2="1799.819"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1360.121,671.32 1376.121,659.32 1393.121,671.32 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1360.121,658.32 1376.121,646.32 1393.121,658.32 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1384.454,698.82c0,4.326-3.507,7.833-7.833,7.833c-4.327,0-7.834-3.507-7.834-7.833
			c0-4.326,3.507-7.833,7.834-7.833C1380.947,690.987,1384.454,694.494,1384.454,698.82"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1365.808,676.32 1376.808,669.57 1387.433,676.445 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1376.621"
            y1="671.82"
            x2="1376.434"
            y2="897.32"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1620.121,671.32 1636.121,659.32 1653.121,671.32 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1620.121,658.32 1636.121,646.32 1653.121,658.32 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1644.454,698.82c0,4.326-3.507,7.833-7.833,7.833c-4.327,0-7.834-3.507-7.834-7.833
			c0-4.326,3.507-7.833,7.834-7.833C1640.947,690.987,1644.454,694.494,1644.454,698.82"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1625.808,676.32 1636.808,669.57 1647.433,676.445 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1636.621"
            y1="671.82"
            x2="1636.434"
            y2="791.82"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="768.421"
            cy="472.82"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="730.588"
            cy="473.007"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="730.588"
            y1="454.632"
            x2="730.588"
            y2="491.382"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="806.838"
            cy="473.007"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="806.838"
            y1="454.632"
            x2="806.838"
            y2="491.382"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="768.421"
            cy="511.57"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="730.588"
            cy="511.757"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="730.588"
            y1="493.382"
            x2="730.588"
            y2="530.132"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="806.838"
            cy="511.757"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="806.838"
            y1="493.382"
            x2="806.838"
            y2="530.132"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="126.421"
            cy="1785.819"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="88.588"
            cy="1786.007"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="88.588"
            y1="1767.632"
            x2="88.588"
            y2="1804.382"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="164.838"
            cy="1786.007"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="164.838"
            y1="1767.632"
            x2="164.838"
            y2="1804.382"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="88.588"
            cy="1824.757"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="88.588"
            y1="1806.382"
            x2="88.588"
            y2="1843.132"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="3899.088"
            cy="1785.819"
            r="14.334"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="3861.254"
            cy="1786.007"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3861.255"
            y1="1767.632"
            x2="3861.255"
            y2="1804.382"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="3937.504"
            cy="1786.007"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3937.505"
            y1="1767.632"
            x2="3937.505"
            y2="1804.382"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="3899.088"
            cy="1824.569"
            r="14.334"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="3861.254"
            cy="1824.757"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3861.255"
            y1="1806.382"
            x2="3861.255"
            y2="1843.132"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="3937.504"
            cy="1824.757"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3937.505"
            y1="1806.382"
            x2="3937.505"
            y2="1843.132"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1034.921"
            cy="472.82"
            r="14.334"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="997.088"
            cy="473.007"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="997.088"
            y1="454.632"
            x2="997.088"
            y2="491.382"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1073.338"
            cy="473.007"
            r="14.334"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1073.338"
            y1="454.632"
            x2="1073.338"
            y2="491.382"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1034.921"
            cy="511.57"
            r="14.334"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="997.088"
            cy="511.757"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="997.088"
            y1="493.382"
            x2="997.088"
            y2="530.132"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1073.338"
            cy="511.757"
            r="14.334"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1073.338"
            y1="493.382"
            x2="1073.338"
            y2="530.132"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1892.921"
            cy="663.32"
            r="14.334"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1855.088"
            cy="663.507"
            r="14.334"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1855.088"
            y1="645.132"
            x2="1855.088"
            y2="681.882"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1931.338"
            cy="663.507"
            r="14.334"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1931.338"
            y1="645.132"
            x2="1931.338"
            y2="681.882"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1892.921"
            cy="702.07"
            r="14.334"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1855.088"
            cy="702.257"
            r="14.334"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1855.088"
            y1="683.882"
            x2="1855.088"
            y2="720.632"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1931.338"
            cy="702.257"
            r="14.334"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1931.338"
            y1="683.882"
            x2="1931.338"
            y2="720.632"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2763.921"
            cy="663.32"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2726.088"
            cy="663.507"
            r="14.334"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2726.088"
            y1="645.132"
            x2="2726.088"
            y2="681.882"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2802.338"
            cy="663.507"
            r="14.334"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2802.338"
            y1="645.132"
            x2="2802.338"
            y2="681.882"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2763.921"
            cy="702.07"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2726.088"
            cy="702.257"
            r="14.334"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2726.088"
            y1="683.882"
            x2="2726.088"
            y2="720.632"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2802.338"
            cy="702.257"
            r="14.334"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2802.338"
            y1="683.882"
            x2="2802.338"
            y2="720.632"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1032.005,362.82 1032.005,1032.32 1526.505,1032.32 1526.505,360.82 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1151.505,827.82 1151.505,623.32 921.505,623.32 921.505,654.32 		"
          />

          <rect
            x="1137.505"
            y="716.32"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="26"
            height="35"
          />

          <rect
            x="1363.505"
            y="790.82"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="26"
            height="35"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1151.755"
            cy="846.07"
            r="15.75"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1151.755"
            cy="870.07"
            r="15.75"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1377.755"
            cy="918.57"
            r="15.75"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1377.755"
            cy="942.57"
            r="15.75"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1152.755,845.32 1227.005,845.32 1227.005,944.82 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1155.005"
            y1="871.32"
            x2="1227.505"
            y2="871.32"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1637.005"
            y1="827.82"
            x2="1637.005"
            y2="871.32"
          />

          <rect
            x="1622.505"
            y="790.82"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            width="26"
            height="35"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1622.005"
            y1="800.32"
            x2="1647.505"
            y2="800.32"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1622.005"
            y1="809.32"
            x2="1647.505"
            y2="809.32"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1622.005"
            y1="816.82"
            x2="1647.505"
            y2="816.82"
          />

          <rect
            x="1805.505"
            y="863.82"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            width="26"
            height="35"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1805.005"
            y1="873.32"
            x2="1830.505"
            y2="873.32"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1805.005"
            y1="882.32"
            x2="1830.505"
            y2="882.32"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1805.005"
            y1="889.82"
            x2="1830.505"
            y2="889.82"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1820.005"
            y1="901.32"
            x2="1820.005"
            y2="944.82"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1820.005,861.82 1820.005,809.82 2037.005,809.82 2037.005,943.32 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1892.621,604.486 1892.621,1024.819 2183.004,1024.819 2183.004,441.319 2400.504,441.319 2400.504,716.819 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1890.505"
            y1="359.819"
            x2="1890.505"
            y2="429.82"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1964.005"
            y1="810.82"
            x2="1964.005"
            y2="838.82"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2820.584"
            y1="839.07"
            x2="2845.584"
            y2="839.07"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2820.584"
            y1="851.07"
            x2="2845.584"
            y2="851.07"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2833.084"
            cy="880.82"
            r="14.5"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2833.084"
            y1="852.07"
            x2="2833.084"
            y2="864.57"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2833.084,897.07 2833.084,918.82 2904.505,918.82 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2823.084"
            y1="870.736"
            x2="2843.084"
            y2="888.819"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2824.042"
            y1="889.945"
            x2="2842.125"
            y2="869.945"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="2677.584,944.903 2699.584,944.903 2695.834,950.403 2680.584,950.403 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="2681.959,954.653 2695.209,954.653 2693.459,958.903 2684.709,958.903 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="2686.084,962.403 2691.084,962.403 2688.666,965.903 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="2894.084,943.903 2916.084,943.903 2912.334,949.403 2897.084,949.403 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="2898.459,953.653 2911.709,953.653 2909.959,957.903 2901.209,957.903 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="2902.584,961.403 2907.584,961.403 2905.166,964.903 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="3400.084,943.903 3422.084,943.903 3418.334,949.403 3403.084,949.403 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="3404.459,953.653 3417.709,953.653 3415.959,957.903 3407.209,957.903 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="3408.584,961.403 3413.584,961.403 3411.166,964.903 		"
          />

          <rect
            x="2673.505"
            y="863.82"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            width="26"
            height="35"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2673.005"
            y1="873.32"
            x2="2698.505"
            y2="873.32"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2673.005"
            y1="882.32"
            x2="2698.505"
            y2="882.32"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2673.005"
            y1="889.82"
            x2="2698.505"
            y2="889.82"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2688.005"
            y1="901.32"
            x2="2688.005"
            y2="944.82"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2688.005,861.82 2688.005,809.82 2905.005,809.82 2905.005,943.32 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2832.005"
            y1="810.82"
            x2="2832.005"
            y2="838.82"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1376.121,646.32 1376.121,586.987 1636.171,586.987 1636.171,647.987 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2765.505,605.32 2765.505,1024.32 3084.505,1024.32 3084.505,440.32 3302.505,440.32 3302.505,715.32 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2764.505"
            y1="360.319"
            x2="2764.505"
            y2="430.82"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:6;stroke-miterlimit:10;"
            x1="560.504"
            y1="359.32"
            x2="1161.504"
            y2="359.32"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:6;stroke-miterlimit:10;"
            x1="185.505"
            y1="1224.32"
            x2="1980.505"
            y2="1224.32"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:6;stroke-miterlimit:10;"
            x1="2027.413"
            y1="1224.32"
            x2="3822.412"
            y2="1224.32"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:6;stroke-miterlimit:10;"
            x1="1390.505"
            y1="359.32"
            x2="2960.505"
            y2="359.32"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:6;stroke-miterlimit:10;"
            cx="2398.005"
            cy="765.82"
            r="47.5"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:6;stroke-miterlimit:10;"
            cx="2398.005"
            cy="844.82"
            r="47.5"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2396.505,759.32 2383.838,779.32 2411.505,779.32 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2384.505,836.32 2399.505,843.32 2411.838,836.32 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2399.505,859.32 2399.505,843.32 2504.505,843.32 2504.505,944.653 		"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:6;stroke-miterlimit:10;"
            cx="3303.005"
            cy="765.82"
            r="47.5"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:6;stroke-miterlimit:10;"
            cx="3303.005"
            cy="844.82"
            r="47.5"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3301.505,759.32 3288.838,779.32 3316.505,779.32 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3289.505,836.32 3304.505,843.32 3316.838,836.32 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3304.505,859.32 3304.505,843.32 3409.505,843.32 3409.505,944.653 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2398.505,897.32 2398.505,1092.32 125.505,1092.32 125.505,1436.32 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			126.121,1608.986 126.121,2007.319 252.505,2007.319 252.505,1224.319 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2912.954,881.32c0,4.326-3.507,7.833-7.833,7.833c-4.327,0-7.834-3.507-7.834-7.833
			c0-4.326,3.507-7.833,7.834-7.833C2909.447,873.487,2912.954,876.994,2912.954,881.32"
          />

          <rect
            x="2905.38"
            y="855.819"
            transform="matrix(0.9511 0.3088 -0.3088 0.9511 410.1431 -855.6279)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="24.5"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2044.954,881.32c0,4.326-3.507,7.833-7.833,7.833c-4.327,0-7.834-3.507-7.834-7.833
			c0-4.326,3.507-7.833,7.834-7.833C2041.447,873.487,2044.954,876.994,2044.954,881.32"
          />
          <rect
            x="2034.172"
            y="856.32"
            style="clip-path:url(#SVGID_2_);"
            width="6.333"
            height="20.667"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="403.002"
            cy="1554.007"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="365.169"
            cy="1554.194"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="365.169"
            y1="1535.82"
            x2="365.169"
            y2="1572.57"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="441.419"
            cy="1554.194"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="441.419"
            y1="1535.82"
            x2="441.419"
            y2="1572.57"
          />

          <rect
            x="390.294"
            y="1388.986"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            width="26"
            height="35"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="321.82,1880.969 343.82,1880.969 340.07,1886.469 324.82,1886.469 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="326.195,1890.719 339.445,1890.719 337.695,1894.969 328.945,1894.969 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="330.32,1898.469 335.32,1898.469 332.903,1901.969 		"
          />

          <rect
            x="317.74"
            y="1799.886"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            width="26"
            height="35"
          />

          <rect
            x="470.407"
            y="1799.886"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            width="26"
            height="35"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="317.241"
            y1="1809.386"
            x2="342.741"
            y2="1809.386"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="317.241"
            y1="1818.386"
            x2="342.741"
            y2="1818.386"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="317.241"
            y1="1825.886"
            x2="342.741"
            y2="1825.886"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="332.241"
            y1="1837.386"
            x2="332.241"
            y2="1880.886"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M410.546,1366.893c1.635,4.006-0.286,8.578-4.292,10.214
			c-4.005,1.635-8.578-0.287-10.213-4.292c-1.635-4.006,0.287-8.578,4.292-10.213
			C404.339,1360.966,408.912,1362.889,410.546,1366.893"
          />

          <rect
            x="398.295"
            y="1344.057"
            transform="matrix(0.9973 -0.0736 0.0736 0.9973 -98.7294 33.2207)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="24.5"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M491.847,1961.125c1.635,4.006-0.286,8.578-4.292,10.213
			c-4.005,1.636-8.578-0.286-10.213-4.291c-1.635-4.006,0.287-8.578,4.292-10.214C485.64,1955.198,490.211,1957.12,491.847,1961.125
			"
          />

          <rect
            x="479.595"
            y="1938.29"
            transform="matrix(0.9973 -0.0736 0.0736 0.9973 -142.2417 40.8156)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="24.5"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            points="
			331.838,1799.653 331.838,1703.653 483.838,1703.653 483.838,2052.32 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="402.294"
            y1="1223.653"
            x2="404.294"
            y2="1702.32"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="477.76"
            y1="2147.236"
            x2="477.76"
            y2="2122.236"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="489.76"
            y1="2147.236"
            x2="489.76"
            y2="2122.236"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="450.892"
            y1="2080.98"
            x2="472.578"
            y2="2093.416"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="444.922"
            y1="2091.391"
            x2="466.609"
            y2="2103.826"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="516.609"
            y1="2080.98"
            x2="494.923"
            y2="2093.416"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="522.579"
            y1="2091.391"
            x2="500.892"
            y2="2103.826"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            points="
			511.96,2097.698 533.255,2134.581 490.005,2134.581 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            points="
			461.756,2086.965 483.76,2048.854 505.698,2086.853 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            points="
			477.004,2134.581 434.265,2134.581 455.817,2097.25 		"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            cx="3405.532"
            cy="1554.007"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            cx="3367.699"
            cy="1554.194"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3367.699"
            y1="1535.82"
            x2="3367.699"
            y2="1572.57"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            cx="3443.949"
            cy="1554.194"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3443.949"
            y1="1535.82"
            x2="3443.949"
            y2="1572.57"
          />

          <rect
            x="3392.824"
            y="1388.986"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            width="26"
            height="35"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="3324.35,1880.969 3346.35,1880.969 3342.6,1886.469 3327.35,1886.469 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="3328.725,1890.719 3341.975,1890.719 3340.225,1894.969 3331.475,1894.969
			"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="3332.85,1898.469 3337.85,1898.469 3335.433,1901.969 		"
          />

          <rect
            x="3320.271"
            y="1799.886"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            width="26"
            height="35"
          />

          <rect
            x="3472.938"
            y="1799.886"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            width="26"
            height="35"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3319.771"
            y1="1809.386"
            x2="3345.271"
            y2="1809.386"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3319.771"
            y1="1818.386"
            x2="3345.271"
            y2="1818.386"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3319.771"
            y1="1825.886"
            x2="3345.271"
            y2="1825.886"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3334.771"
            y1="1837.386"
            x2="3334.771"
            y2="1880.886"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M3413.076,1366.893c1.635,4.006-0.286,8.578-4.292,10.214
			c-4.005,1.635-8.578-0.287-10.213-4.292c-1.635-4.006,0.287-8.578,4.292-10.213
			C3406.869,1360.966,3411.441,1362.889,3413.076,1366.893"
          />

          <rect
            x="3400.824"
            y="1344.057"
            transform="matrix(0.9973 -0.0736 0.0736 0.9973 -90.5808 254.1731)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="24.5"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M3494.377,1961.125c1.635,4.006-0.287,8.578-4.293,10.213
			c-4.005,1.636-8.578-0.286-10.213-4.291c-1.635-4.006,0.287-8.578,4.292-10.214
			C3488.17,1955.198,3492.741,1957.12,3494.377,1961.125"
          />

          <rect
            x="3482.125"
            y="1938.29"
            transform="matrix(0.9973 -0.0736 0.0736 0.9973 -134.1091 261.8088)"
            style="clip-path:url(#SVGID_2_);"
            width="6.249"
            height="24.5"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            points="
			3334.368,1799.653 3334.368,1703.653 3486.368,1703.653 3486.368,2052.32 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3404.824"
            y1="1223.653"
            x2="3406.824"
            y2="1702.32"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3480.29"
            y1="2147.236"
            x2="3480.29"
            y2="2122.236"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3492.29"
            y1="2147.236"
            x2="3492.29"
            y2="2122.236"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3453.422"
            y1="2080.98"
            x2="3475.108"
            y2="2093.416"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3447.452"
            y1="2091.391"
            x2="3469.139"
            y2="2103.826"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3519.14"
            y1="2080.98"
            x2="3497.453"
            y2="2093.416"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3525.109"
            y1="2091.391"
            x2="3503.422"
            y2="2103.826"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            points="
			3514.49,2097.698 3535.784,2134.581 3492.535,2134.581 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            points="
			3464.286,2086.965 3486.29,2048.854 3508.229,2086.853 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            points="
			3479.535,2134.581 3436.795,2134.581 3458.348,2097.25 		"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            cx="3611.532"
            cy="1554.007"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            cx="3573.699"
            cy="1554.194"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3573.699"
            y1="1535.82"
            x2="3573.699"
            y2="1572.57"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            cx="3649.949"
            cy="1554.194"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3649.949"
            y1="1535.82"
            x2="3649.949"
            y2="1572.57"
          />

          <rect
            x="3598.824"
            y="1388.986"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            width="26"
            height="35"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="3530.35,1880.969 3552.35,1880.969 3548.6,1886.469 3533.35,1886.469 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="3534.725,1890.719 3547.975,1890.719 3546.225,1894.969 3537.475,1894.969
			"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="3538.85,1898.469 3543.85,1898.469 3541.433,1901.969 		"
          />

          <rect
            x="3526.271"
            y="1799.886"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            width="26"
            height="35"
          />

          <rect
            x="3679.938"
            y="1799.886"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            width="26"
            height="35"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3525.771"
            y1="1809.386"
            x2="3551.271"
            y2="1809.386"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3525.771"
            y1="1818.386"
            x2="3551.271"
            y2="1818.386"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3525.771"
            y1="1825.886"
            x2="3551.271"
            y2="1825.886"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3540.771"
            y1="1837.386"
            x2="3540.771"
            y2="1880.886"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M3619.076,1366.893c1.635,4.006-0.286,8.578-4.292,10.214
			c-4.005,1.635-8.578-0.287-10.213-4.292c-1.635-4.006,0.287-8.578,4.292-10.213
			C3612.869,1360.966,3617.441,1362.889,3619.076,1366.893"
          />

          <rect
            x="3606.824"
            y="1344.057"
            transform="matrix(0.9973 -0.0736 0.0736 0.9973 -90.0222 269.3325)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="24.5"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M3700.377,1961.125c1.635,4.006-0.287,8.578-4.293,10.213
			c-4.005,1.636-8.578-0.286-10.213-4.291c-1.635-4.006,0.287-8.578,4.292-10.214
			C3694.17,1955.198,3698.741,1957.12,3700.377,1961.125"
          />

          <rect
            x="3688.125"
            y="1938.29"
            transform="matrix(0.9973 -0.0736 0.0736 0.9973 -133.5505 276.9706)"
            style="clip-path:url(#SVGID_2_);"
            width="6.249"
            height="24.5"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            points="
			3540.368,1799.653 3540.368,1703.653 3692.368,1703.653 3692.368,2052.32 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3610.824"
            y1="1223.653"
            x2="3612.824"
            y2="1702.32"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3686.29"
            y1="2147.236"
            x2="3686.29"
            y2="2122.236"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3698.29"
            y1="2147.236"
            x2="3698.29"
            y2="2122.236"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3659.422"
            y1="2080.98"
            x2="3681.108"
            y2="2093.416"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3653.452"
            y1="2091.391"
            x2="3675.139"
            y2="2103.826"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3725.14"
            y1="2080.98"
            x2="3703.453"
            y2="2093.416"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="3731.109"
            y1="2091.391"
            x2="3709.422"
            y2="2103.826"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            points="
			3720.49,2097.698 3741.784,2134.581 3698.535,2134.581 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            points="
			3670.286,2086.965 3692.29,2048.854 3714.229,2086.853 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            points="
			3685.535,2134.581 3642.795,2134.581 3664.348,2097.25 		"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="630.002"
            cy="1554.007"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="592.169"
            cy="1554.194"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="592.169"
            y1="1535.82"
            x2="592.169"
            y2="1572.57"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="668.419"
            cy="1554.194"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="668.419"
            y1="1535.82"
            x2="668.419"
            y2="1572.57"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="824.097"
            cy="1476.008"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="786.264"
            cy="1476.195"
            r="14.334"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="786.264"
            y1="1457.82"
            x2="786.264"
            y2="1494.57"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="862.514"
            cy="1476.195"
            r="14.334"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="862.514"
            y1="1457.82"
            x2="862.514"
            y2="1494.57"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2076.097"
            cy="1678.007"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2038.264"
            cy="1678.194"
            r="14.334"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2038.264"
            y1="1659.819"
            x2="2038.264"
            y2="1696.569"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2114.514"
            cy="1678.194"
            r="14.334"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2114.514"
            y1="1659.819"
            x2="2114.514"
            y2="1696.569"
          />

          <rect
            x="617.294"
            y="1388.986"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="26"
            height="35"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="548.819,1880.969 570.819,1880.969 567.069,1886.469 551.819,1886.469 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="553.194,1890.719 566.444,1890.719 564.694,1894.969 555.944,1894.969 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);"
            points="557.319,1898.469 562.319,1898.469 559.902,1901.969 		"
          />

          <rect
            x="544.74"
            y="1799.886"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="26"
            height="35"
          />

          <rect
            x="697.407"
            y="1799.886"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="26"
            height="35"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="544.24"
            y1="1809.386"
            x2="569.74"
            y2="1809.386"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="544.24"
            y1="1818.386"
            x2="569.74"
            y2="1818.386"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="544.24"
            y1="1825.886"
            x2="569.74"
            y2="1825.886"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="559.24"
            y1="1837.386"
            x2="559.24"
            y2="1880.886"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M637.546,1366.893c1.635,4.006-0.286,8.578-4.292,10.214
			c-4.005,1.635-8.578-0.287-10.213-4.292c-1.635-4.006,0.287-8.578,4.292-10.213
			C631.339,1360.966,635.911,1362.889,637.546,1366.893"
          />

          <rect
            x="625.294"
            y="1344.057"
            transform="matrix(0.9973 -0.0736 0.0736 0.9973 -98.1138 49.9269)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="24.5"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M707.068,1946.38c3.877-1.92,8.576-0.334,10.496,3.543s0.334,8.576-3.543,10.496
			s-8.576,0.334-10.496-3.543C701.605,1952.999,703.191,1948.3,707.068,1946.38"
          />

          <rect
            x="694.043"
            y="1943.997"
            transform="matrix(-0.1454 -0.9894 0.9894 -0.1454 -1136.8768 2930.5281)"
            style="clip-path:url(#SVGID_2_);"
            width="6.251"
            height="24.5"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="710.838"
            y1="1957.319"
            x2="710.838"
            y2="2052.319"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			558.838,1799.653 558.838,1703.653 710.838,1703.653 710.838,1932.82 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="629.294"
            y1="1223.653"
            x2="631.294"
            y2="1702.32"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="704.76"
            y1="2147.236"
            x2="704.76"
            y2="2122.236"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="716.76"
            y1="2147.236"
            x2="716.76"
            y2="2122.236"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="677.892"
            y1="2080.98"
            x2="699.578"
            y2="2093.416"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="671.922"
            y1="2091.391"
            x2="693.609"
            y2="2103.826"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="743.609"
            y1="2080.98"
            x2="721.923"
            y2="2093.416"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="749.579"
            y1="2091.391"
            x2="727.892"
            y2="2103.826"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            points="
			738.96,2097.698 760.255,2134.581 717.005,2134.581 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            points="
			688.756,2086.965 710.76,2048.854 732.699,2086.853 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            points="
			704.004,2134.581 661.265,2134.581 682.817,2097.25 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="825.389"
            y1="1824.486"
            x2="825.389"
            y2="2017.82"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="3227.097"
            cy="1476.008"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="3189.264"
            cy="1476.195"
            r="14.334"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="3189.264"
            y1="1457.82"
            x2="3189.264"
            y2="1494.57"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="3265.514"
            cy="1476.195"
            r="14.334"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="3265.514"
            y1="1457.82"
            x2="3265.514"
            y2="1494.57"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="3222.389"
            y1="1224.32"
            x2="3228.389"
            y2="1645.32"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="3228.389"
            y1="1816.986"
            x2="3228.389"
            y2="2010.32"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			834.008,2018.819 825.388,2033.749 816.769,2018.819 		"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3236.744,2011.319 3228.125,2026.25 3219.504,2011.319 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2885.207,1634.669 2873.207,1618.669 2885.207,1601.669 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2872.207,1634.669 2860.207,1618.669 2872.207,1601.669 		"
          />

          <rect
            x="2930.206"
            y="1599.836"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2948.54,1610.336c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			s-7.833-3.507-7.833-7.834C2940.707,1613.843,2944.214,1610.336,2948.54,1610.336"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2912.707,1610.336c4.325,0,7.832,3.507,7.832,7.833c0,4.327-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.507-7.834-7.834C2904.873,1613.843,2908.381,1610.336,2912.707,1610.336"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2890.207,1628.981 2883.457,1617.981 2890.332,1607.356 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2969.04"
            y1="1618.075"
            x2="3002.04"
            y2="1618.263"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2881.707"
            y1="1618.075"
            x2="2931.374"
            y2="1618.263"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2831.04"
            y1="1618.075"
            x2="2859.707"
            y2="1618.263"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2987.311"
            cy="1618.461"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2987.498"
            cy="1656.294"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2969.123"
            y1="1656.294"
            x2="3005.873"
            y2="1656.294"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2987.498"
            cy="1580.044"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2969.123"
            y1="1580.044"
            x2="3005.873"
            y2="1580.044"
          />

          <rect
            x="2945.484"
            y="1599.2"
            transform="matrix(-0.0105 -0.9999 0.9999 -0.0105 1361.3953 4583.5566)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.939"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="3071.707"
            y1="1618.076"
            x2="3118.039"
            y2="1618.263"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3049.873,1601.669 3060.873,1617.669 3049.873,1634.669 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3062.873,1601.669 3073.873,1617.669 3062.873,1634.669 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M3026.707,1610.336c4.325,0,7.832,3.507,7.832,7.833c0,4.327-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.507-7.834-7.834C3018.873,1613.843,3022.381,1610.336,3026.707,1610.336"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3046.957,1607.356 3053.707,1618.356 3046.832,1628.981 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="3006.04"
            y1="1618.075"
            x2="3054.707"
            y2="1618.263"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3117.792,1611.883 3132.723,1620.503 3117.792,1629.123 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2562.207,1369.549 2550.207,1353.549 2562.207,1336.549 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2549.207,1369.549 2537.207,1353.549 2549.207,1336.549 		"
          />

          <rect
            x="2607.206"
            y="1334.716"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2625.54,1345.216c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			s-7.833-3.507-7.833-7.834C2617.707,1348.723,2621.214,1345.216,2625.54,1345.216"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2589.707,1345.216c4.325,0,7.832,3.507,7.832,7.833c0,4.327-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.507-7.834-7.834C2581.873,1348.723,2585.381,1345.216,2589.707,1345.216"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2567.207,1363.861 2560.457,1352.861 2567.332,1342.236 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2646.04"
            y1="1352.955"
            x2="2679.04"
            y2="1353.143"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2558.707"
            y1="1352.955"
            x2="2608.374"
            y2="1353.143"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2508.04"
            y1="1352.955"
            x2="2536.707"
            y2="1353.142"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2664.311"
            cy="1353.34"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2664.498"
            cy="1391.174"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2646.123"
            y1="1391.174"
            x2="2682.873"
            y2="1391.174"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2664.498"
            cy="1314.924"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2646.123"
            y1="1314.924"
            x2="2682.873"
            y2="1314.924"
          />

          <rect
            x="2622.484"
            y="1334.08"
            transform="matrix(-0.0105 -0.9999 0.9999 -0.0105 1300.1201 3992.6785)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.939"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2748.707"
            y1="1352.955"
            x2="2795.039"
            y2="1353.143"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2726.873,1336.549 2737.873,1352.549 2726.873,1369.549 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2739.873,1336.549 2750.873,1352.549 2739.873,1369.549 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2703.707,1345.216c4.325,0,7.832,3.507,7.832,7.833c0,4.327-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.507-7.834-7.834C2695.873,1348.723,2699.381,1345.216,2703.707,1345.216"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2723.957,1342.236 2730.707,1353.236 2723.832,1363.861 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2683.04"
            y1="1352.955"
            x2="2731.707"
            y2="1353.143"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2794.792,1346.763 2809.723,1355.383 2794.792,1364.002 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2562.207,1518.782 2550.207,1502.782 2562.207,1485.782 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2549.207,1518.782 2537.207,1502.782 2549.207,1485.782 		"
          />

          <rect
            x="2607.206"
            y="1483.949"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.666"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2625.54,1494.449c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			s-7.833-3.507-7.833-7.834C2617.707,1497.956,2621.214,1494.449,2625.54,1494.449"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2589.707,1494.449c4.325,0,7.832,3.507,7.832,7.833c0,4.327-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.507-7.834-7.834C2581.873,1497.956,2585.381,1494.449,2589.707,1494.449"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2567.207,1513.095 2560.457,1502.095 2567.332,1491.47 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2646.04"
            y1="1502.188"
            x2="2679.04"
            y2="1502.376"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2558.707"
            y1="1502.188"
            x2="2608.374"
            y2="1502.376"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2508.04"
            y1="1502.188"
            x2="2536.707"
            y2="1502.375"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2664.311"
            cy="1502.575"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2664.498"
            cy="1540.408"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2646.123"
            y1="1540.407"
            x2="2682.873"
            y2="1540.407"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2664.498"
            cy="1464.158"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2646.123"
            y1="1464.157"
            x2="2682.873"
            y2="1464.157"
          />

          <rect
            x="2622.484"
            y="1483.313"
            transform="matrix(-0.0105 -0.9999 0.9999 -0.0105 1150.8944 4143.4746)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.939"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2748.707"
            y1="1502.188"
            x2="2795.039"
            y2="1502.376"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2726.873,1485.782 2737.873,1501.782 2726.873,1518.782 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2739.873,1485.782 2750.873,1501.782 2739.873,1518.782 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2703.707,1494.449c4.325,0,7.832,3.507,7.832,7.833c0,4.327-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.507-7.834-7.834C2695.873,1497.956,2699.381,1494.449,2703.707,1494.449"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2723.957,1491.47 2730.707,1502.47 2723.832,1513.095 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2683.04"
            y1="1502.188"
            x2="2731.707"
            y2="1502.376"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2794.792,1495.996 2809.723,1504.616 2794.792,1513.236 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2562.207,1668.016 2550.207,1652.016 2562.207,1635.016 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2549.207,1668.016 2537.207,1652.016 2549.207,1635.016 		"
          />

          <rect
            x="2607.206"
            y="1633.183"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2625.54,1643.683c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			s-7.833-3.507-7.833-7.834C2617.707,1647.189,2621.214,1643.683,2625.54,1643.683"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2589.707,1643.683c4.325,0,7.832,3.507,7.832,7.833c0,4.327-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.507-7.834-7.834C2581.873,1647.189,2585.381,1643.683,2589.707,1643.683"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2567.207,1662.328 2560.457,1651.328 2567.332,1640.703 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2646.04"
            y1="1651.422"
            x2="2679.04"
            y2="1651.609"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2558.707"
            y1="1651.422"
            x2="2608.374"
            y2="1651.609"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2508.04"
            y1="1651.422"
            x2="2536.707"
            y2="1651.609"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2664.311"
            cy="1651.808"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2664.498"
            cy="1689.641"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2646.123"
            y1="1689.641"
            x2="2682.873"
            y2="1689.641"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2664.498"
            cy="1613.391"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2646.123"
            y1="1613.391"
            x2="2682.873"
            y2="1613.391"
          />

          <rect
            x="2622.484"
            y="1632.547"
            transform="matrix(-0.0105 -0.9999 0.9999 -0.0105 1001.6692 4294.27)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.939"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2748.707"
            y1="1651.422"
            x2="2795.039"
            y2="1651.609"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2726.873,1635.016 2737.873,1651.016 2726.873,1668.016 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2739.873,1635.016 2750.873,1651.016 2739.873,1668.016 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2703.707,1643.683c4.325,0,7.832,3.507,7.832,7.833c0,4.327-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.507-7.834-7.834C2695.873,1647.189,2699.381,1643.683,2703.707,1643.683"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2723.957,1640.703 2730.707,1651.703 2723.832,1662.328 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2683.04"
            y1="1651.422"
            x2="2731.707"
            y2="1651.609"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2794.792,1645.229 2809.723,1653.85 2794.792,1662.47 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2562.207,1817.25 2550.207,1801.25 2562.207,1784.25 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2549.207,1817.25 2537.207,1801.25 2549.207,1784.25 		"
          />

          <rect
            x="2607.206"
            y="1782.416"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2625.54,1792.916c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			s-7.833-3.507-7.833-7.834C2617.707,1796.423,2621.214,1792.916,2625.54,1792.916"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2589.707,1792.916c4.325,0,7.832,3.507,7.832,7.833c0,4.327-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.507-7.834-7.834C2581.873,1796.423,2585.381,1792.916,2589.707,1792.916"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2567.207,1811.563 2560.457,1800.563 2567.332,1789.938 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2646.04"
            y1="1800.656"
            x2="2679.04"
            y2="1800.843"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2558.707"
            y1="1800.656"
            x2="2608.374"
            y2="1800.843"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2508.04"
            y1="1800.655"
            x2="2536.707"
            y2="1800.843"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2664.311"
            cy="1801.042"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2664.498"
            cy="1838.875"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2646.123"
            y1="1838.875"
            x2="2682.873"
            y2="1838.875"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2664.498"
            cy="1762.625"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2646.123"
            y1="1762.625"
            x2="2682.873"
            y2="1762.625"
          />

          <rect
            x="2622.484"
            y="1781.781"
            transform="matrix(-0.0105 -0.9999 0.9999 -0.0105 852.4435 4445.0664)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.939"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2748.707"
            y1="1800.656"
            x2="2795.039"
            y2="1800.843"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2726.873,1784.25 2737.873,1800.25 2726.873,1817.25 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2739.873,1784.25 2750.873,1800.25 2739.873,1817.25 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2703.707,1792.916c4.325,0,7.832,3.507,7.832,7.833c0,4.327-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.507-7.834-7.834C2695.873,1796.423,2699.381,1792.916,2703.707,1792.916"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2723.957,1789.938 2730.707,1800.938 2723.832,1811.563 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2683.04"
            y1="1800.656"
            x2="2731.707"
            y2="1800.843"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2794.792,1794.463 2809.723,1803.083 2794.792,1811.703 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2562.207,1966.483 2550.207,1950.483 2562.207,1933.483 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2549.207,1966.483 2537.207,1950.483 2549.207,1933.483 		"
          />

          <rect
            x="2607.206"
            y="1931.649"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2625.54,1942.15c4.326,0,7.833,3.507,7.833,7.833s-3.507,7.834-7.833,7.834
			s-7.833-3.508-7.833-7.834S2621.214,1942.15,2625.54,1942.15"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2589.707,1942.15c4.325,0,7.832,3.507,7.832,7.833s-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.508-7.834-7.834S2585.381,1942.15,2589.707,1942.15"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2567.207,1960.796 2560.457,1949.796 2567.332,1939.171 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2646.04"
            y1="1949.89"
            x2="2679.04"
            y2="1950.076"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2558.707"
            y1="1949.89"
            x2="2608.374"
            y2="1950.076"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2508.04"
            y1="1949.889"
            x2="2536.707"
            y2="1950.076"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2664.311"
            cy="1950.275"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2664.498"
            cy="1988.109"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2646.123"
            y1="1988.108"
            x2="2682.873"
            y2="1988.108"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2664.498"
            cy="1911.859"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2646.123"
            y1="1911.858"
            x2="2682.873"
            y2="1911.858"
          />

          <rect
            x="2622.484"
            y="1931.014"
            transform="matrix(-0.0105 -0.9999 0.9999 -0.0105 703.2183 4595.8618)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.939"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2748.707"
            y1="1949.89"
            x2="2795.039"
            y2="1950.076"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2726.873,1933.483 2737.873,1949.483 2726.873,1966.483 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2739.873,1933.483 2750.873,1949.483 2739.873,1966.483 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2703.707,1942.15c4.325,0,7.832,3.507,7.832,7.833s-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.508-7.834-7.834S2699.381,1942.15,2703.707,1942.15"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2723.957,1939.171 2730.707,1950.171 2723.832,1960.796 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2683.04"
            y1="1949.89"
            x2="2731.707"
            y2="1950.076"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2794.792,1943.696 2809.723,1952.316 2794.792,1960.937 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2562.207,2115.717 2550.207,2099.717 2562.207,2082.717 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2549.207,2115.717 2537.207,2099.717 2549.207,2082.717 		"
          />

          <rect
            x="2607.206"
            y="2080.884"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2625.54,2091.384c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			s-7.833-3.507-7.833-7.834C2617.707,2094.891,2621.214,2091.384,2625.54,2091.384"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2589.707,2091.384c4.325,0,7.832,3.507,7.832,7.833c0,4.327-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.507-7.834-7.834C2581.873,2094.891,2585.381,2091.384,2589.707,2091.384"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2567.207,2110.029 2560.457,2099.029 2567.332,2088.404 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2646.04"
            y1="2099.123"
            x2="2679.04"
            y2="2099.311"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2558.707"
            y1="2099.123"
            x2="2608.374"
            y2="2099.311"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2508.04"
            y1="2099.123"
            x2="2536.707"
            y2="2099.31"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2664.311"
            cy="2099.508"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2664.498"
            cy="2137.342"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2646.123"
            y1="2137.342"
            x2="2682.873"
            y2="2137.342"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2664.498"
            cy="2061.092"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2646.123"
            y1="2061.092"
            x2="2682.873"
            y2="2061.092"
          />

          <rect
            x="2622.484"
            y="2080.248"
            transform="matrix(-0.0105 -0.9999 0.9999 -0.0105 553.9924 4746.6582)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.939"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2748.707"
            y1="2099.123"
            x2="2795.039"
            y2="2099.311"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2726.873,2082.717 2737.873,2098.717 2726.873,2115.717 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2739.873,2082.717 2750.873,2098.717 2739.873,2115.717 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2703.707,2091.384c4.325,0,7.832,3.507,7.832,7.833c0,4.327-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.507-7.834-7.834C2695.873,2094.891,2699.381,2091.384,2703.707,2091.384"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2723.957,2088.404 2730.707,2099.404 2723.832,2110.029 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2683.04"
            y1="2099.123"
            x2="2731.707"
            y2="2099.311"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2794.792,2092.931 2809.723,2101.551 2794.792,2110.17 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2247.207,2200.169 2235.207,2184.169 2247.207,2167.169 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2234.207,2200.169 2222.207,2184.169 2234.207,2167.169 		"
          />

          <rect
            x="2292.206"
            y="2165.336"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2310.54,2175.836c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			s-7.833-3.507-7.833-7.834C2302.707,2179.343,2306.214,2175.836,2310.54,2175.836"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2274.707,2175.836c4.325,0,7.832,3.507,7.832,7.833c0,4.327-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.507-7.834-7.834C2266.873,2179.343,2270.381,2175.836,2274.707,2175.836"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2252.207,2194.481 2245.457,2183.481 2252.332,2172.856 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2331.04"
            y1="2183.575"
            x2="2364.04"
            y2="2183.763"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2243.707"
            y1="2183.575"
            x2="2293.374"
            y2="2183.763"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2193.04"
            y1="2183.575"
            x2="2221.707"
            y2="2183.762"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2349.311"
            cy="2183.961"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2349.498"
            cy="2221.794"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2331.123"
            y1="2221.794"
            x2="2367.873"
            y2="2221.794"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2349.498"
            cy="2145.544"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2331.123"
            y1="2145.544"
            x2="2367.873"
            y2="2145.544"
          />

          <rect
            x="2307.484"
            y="2164.7"
            transform="matrix(-0.0105 -0.9999 0.9999 -0.0105 151.2476 4517.0117)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.939"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2433.707"
            y1="2183.575"
            x2="2480.039"
            y2="2183.763"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2411.873,2167.169 2422.873,2183.169 2411.873,2200.169 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2424.873,2167.169 2435.873,2183.169 2424.873,2200.169 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2388.707,2175.836c4.325,0,7.832,3.507,7.832,7.833c0,4.327-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.507-7.834-7.834C2380.873,2179.343,2384.381,2175.836,2388.707,2175.836"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2408.957,2172.856 2415.707,2183.856 2408.832,2194.481 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2368.04"
            y1="2183.575"
            x2="2416.707"
            y2="2183.763"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2479.792,2177.383 2494.723,2186.003 2479.792,2194.623 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2247.207,2052.563 2235.207,2036.563 2247.207,2019.563 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2234.207,2052.563 2222.207,2036.563 2234.207,2019.563 		"
          />

          <rect
            x="2292.206"
            y="2017.729"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2310.54,2028.229c4.326,0,7.833,3.507,7.833,7.833s-3.507,7.834-7.833,7.834
			s-7.833-3.508-7.833-7.834S2306.214,2028.229,2310.54,2028.229"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2274.707,2028.229c4.325,0,7.832,3.507,7.832,7.833s-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.508-7.834-7.834S2270.381,2028.229,2274.707,2028.229"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2252.207,2046.875 2245.457,2035.875 2252.332,2025.25 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2331.04"
            y1="2035.969"
            x2="2364.04"
            y2="2036.155"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2243.707"
            y1="2035.969"
            x2="2293.374"
            y2="2036.155"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2193.04"
            y1="2035.969"
            x2="2221.707"
            y2="2036.155"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2349.311"
            cy="2036.354"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2349.498"
            cy="2074.188"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2331.123"
            y1="2074.188"
            x2="2367.873"
            y2="2074.188"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2349.498"
            cy="1997.938"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2331.123"
            y1="1997.938"
            x2="2367.873"
            y2="1997.938"
          />

          <rect
            x="2307.484"
            y="2017.093"
            transform="matrix(-0.0105 -0.9999 0.9999 -0.0105 298.8464 4367.8594)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.939"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2433.707"
            y1="2035.969"
            x2="2480.039"
            y2="2036.155"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2411.873,2019.563 2422.873,2035.563 2411.873,2052.563 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2424.873,2019.563 2435.873,2035.563 2424.873,2052.563 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2388.707,2028.229c4.325,0,7.832,3.507,7.832,7.833s-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.508-7.834-7.834S2384.381,2028.229,2388.707,2028.229"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2408.957,2025.25 2415.707,2036.25 2408.832,2046.875 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2368.04"
            y1="2035.969"
            x2="2416.707"
            y2="2036.155"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2479.792,2029.775 2494.723,2038.396 2479.792,2047.016 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2247.207,1904.955 2235.207,1888.955 2247.207,1871.955 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2234.207,1904.955 2222.207,1888.955 2234.207,1871.955 		"
          />

          <rect
            x="2292.206"
            y="1870.122"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2310.54,1880.622c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			s-7.833-3.507-7.833-7.834C2302.707,1884.129,2306.214,1880.622,2310.54,1880.622"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2274.707,1880.622c4.325,0,7.832,3.507,7.832,7.833c0,4.327-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.507-7.834-7.834C2266.873,1884.129,2270.381,1880.622,2274.707,1880.622"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2252.207,1899.268 2245.457,1888.268 2252.332,1877.643 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2331.04"
            y1="1888.361"
            x2="2364.04"
            y2="1888.549"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2243.707"
            y1="1888.361"
            x2="2293.374"
            y2="1888.549"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2193.04"
            y1="1888.361"
            x2="2221.707"
            y2="1888.549"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2349.311"
            cy="1888.748"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2349.498"
            cy="1926.581"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2331.123"
            y1="1926.58"
            x2="2367.873"
            y2="1926.58"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2349.498"
            cy="1850.331"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2331.123"
            y1="1850.33"
            x2="2367.873"
            y2="1850.33"
          />

          <rect
            x="2307.484"
            y="1869.486"
            transform="matrix(-0.0105 -0.9999 0.9999 -0.0105 446.4452 4218.707)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.939"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2433.707"
            y1="1888.361"
            x2="2480.039"
            y2="1888.549"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2411.873,1871.955 2422.873,1887.955 2411.873,1904.955 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2424.873,1871.955 2435.873,1887.955 2424.873,1904.955 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2388.707,1880.622c4.325,0,7.832,3.507,7.832,7.833c0,4.327-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.507-7.834-7.834C2380.873,1884.129,2384.381,1880.622,2388.707,1880.622"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2408.957,1877.643 2415.707,1888.643 2408.832,1899.268 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2368.04"
            y1="1888.361"
            x2="2416.707"
            y2="1888.549"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2479.792,1882.169 2494.723,1890.789 2479.792,1899.409 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2247.207,1757.349 2235.207,1741.349 2247.207,1724.349 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2234.207,1757.349 2222.207,1741.349 2234.207,1724.349 		"
          />

          <rect
            x="2292.206"
            y="1722.515"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2310.54,1733.016c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			s-7.833-3.507-7.833-7.834C2302.707,1736.522,2306.214,1733.016,2310.54,1733.016"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2274.707,1733.016c4.325,0,7.832,3.507,7.832,7.833c0,4.327-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.507-7.834-7.834C2266.873,1736.522,2270.381,1733.016,2274.707,1733.016"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2252.207,1751.661 2245.457,1740.661 2252.332,1730.036 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2331.04"
            y1="1740.755"
            x2="2364.04"
            y2="1740.942"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2243.707"
            y1="1740.755"
            x2="2293.374"
            y2="1740.942"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2193.04"
            y1="1740.755"
            x2="2221.707"
            y2="1740.941"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2349.311"
            cy="1741.14"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2349.498"
            cy="1778.974"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2331.123"
            y1="1778.974"
            x2="2367.873"
            y2="1778.974"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2349.498"
            cy="1702.724"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2331.123"
            y1="1702.724"
            x2="2367.873"
            y2="1702.724"
          />

          <rect
            x="2307.484"
            y="1721.88"
            transform="matrix(-0.0105 -0.9999 0.9999 -0.0105 594.0436 4069.5557)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.939"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2433.707"
            y1="1740.755"
            x2="2480.039"
            y2="1740.942"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2411.873,1724.349 2422.873,1740.349 2411.873,1757.349 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2424.873,1724.349 2435.873,1740.349 2424.873,1757.349 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2388.707,1733.016c4.325,0,7.832,3.507,7.832,7.833c0,4.327-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.507-7.834-7.834C2380.873,1736.522,2384.381,1733.016,2388.707,1733.016"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2408.957,1730.036 2415.707,1741.036 2408.832,1751.661 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2368.04"
            y1="1740.755"
            x2="2416.707"
            y2="1740.942"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2479.792,1734.563 2494.723,1743.182 2479.792,1751.802 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2247.207,1609.742 2235.207,1593.742 2247.207,1576.742 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2234.207,1609.742 2222.207,1593.742 2234.207,1576.742 		"
          />

          <rect
            x="2292.206"
            y="1574.908"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.666"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2310.54,1585.408c4.326,0,7.833,3.508,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			s-7.833-3.507-7.833-7.834C2302.707,1588.916,2306.214,1585.408,2310.54,1585.408"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2274.707,1585.408c4.325,0,7.832,3.508,7.832,7.833c0,4.327-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.507-7.834-7.834C2266.873,1588.916,2270.381,1585.408,2274.707,1585.408"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2252.207,1604.055 2245.457,1593.055 2252.332,1582.43 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2331.04"
            y1="1593.148"
            x2="2364.04"
            y2="1593.335"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2243.707"
            y1="1593.148"
            x2="2293.374"
            y2="1593.335"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2193.04"
            y1="1593.147"
            x2="2221.707"
            y2="1593.335"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2349.311"
            cy="1593.534"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2349.498"
            cy="1631.367"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2331.123"
            y1="1631.367"
            x2="2367.873"
            y2="1631.367"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2349.498"
            cy="1555.117"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2331.123"
            y1="1555.117"
            x2="2367.873"
            y2="1555.117"
          />

          <rect
            x="2307.484"
            y="1574.273"
            transform="matrix(-0.0105 -0.9999 0.9999 -0.0105 741.6425 3920.4036)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.939"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2433.707"
            y1="1593.148"
            x2="2480.039"
            y2="1593.335"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2411.873,1576.742 2422.873,1592.742 2411.873,1609.742 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2424.873,1576.742 2435.873,1592.742 2424.873,1609.742 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2388.707,1585.408c4.325,0,7.832,3.508,7.832,7.833c0,4.327-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.507-7.834-7.834C2380.873,1588.916,2384.381,1585.408,2388.707,1585.408"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2408.957,1582.43 2415.707,1593.43 2408.832,1604.055 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2368.04"
            y1="1593.148"
            x2="2416.707"
            y2="1593.335"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2479.792,1586.955 2494.723,1595.575 2479.792,1604.195 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2247.207,1462.135 2235.207,1446.135 2247.207,1429.135 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2234.207,1462.135 2222.207,1446.135 2234.207,1429.135 		"
          />

          <rect
            x="2292.206"
            y="1427.302"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2310.54,1437.802c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			s-7.833-3.507-7.833-7.834C2302.707,1441.309,2306.214,1437.802,2310.54,1437.802"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2274.707,1437.802c4.325,0,7.832,3.507,7.832,7.833c0,4.327-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.507-7.834-7.834C2266.873,1441.309,2270.381,1437.802,2274.707,1437.802"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2252.207,1456.447 2245.457,1445.447 2252.332,1434.822 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2331.04"
            y1="1445.541"
            x2="2364.04"
            y2="1445.729"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2243.707"
            y1="1445.541"
            x2="2293.374"
            y2="1445.729"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2193.04"
            y1="1445.541"
            x2="2221.707"
            y2="1445.728"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2349.311"
            cy="1445.927"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2349.498"
            cy="1483.76"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2331.123"
            y1="1483.76"
            x2="2367.873"
            y2="1483.76"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2349.498"
            cy="1407.51"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2331.123"
            y1="1407.51"
            x2="2367.873"
            y2="1407.51"
          />

          <rect
            x="2307.484"
            y="1426.666"
            transform="matrix(-0.0105 -0.9999 0.9999 -0.0105 889.2413 3771.2515)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.939"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2433.707"
            y1="1445.541"
            x2="2480.039"
            y2="1445.729"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2411.873,1429.135 2422.873,1445.135 2411.873,1462.135 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2424.873,1429.135 2435.873,1445.135 2424.873,1462.135 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2388.707,1437.802c4.325,0,7.832,3.507,7.832,7.833c0,4.327-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.507-7.834-7.834C2380.873,1441.309,2384.381,1437.802,2388.707,1437.802"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2408.957,1434.822 2415.707,1445.822 2408.832,1456.447 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2368.04"
            y1="1445.541"
            x2="2416.707"
            y2="1445.729"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2479.792,1439.349 2494.723,1447.969 2479.792,1456.589 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			984.207,1634.669 972.207,1618.669 984.207,1601.669 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			971.207,1634.669 959.207,1618.669 971.207,1601.669 		"
          />

          <rect
            x="1029.206"
            y="1599.836"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1047.54,1610.336c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			s-7.833-3.507-7.833-7.834C1039.707,1613.843,1043.214,1610.336,1047.54,1610.336"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1011.707,1610.336c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1003.874,1613.843,1007.381,1610.336,1011.707,1610.336"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			989.207,1628.981 982.457,1617.981 989.332,1607.356 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1068.04"
            y1="1618.075"
            x2="1101.04"
            y2="1618.263"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="980.707"
            y1="1618.075"
            x2="1030.374"
            y2="1618.263"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="930.04"
            y1="1618.075"
            x2="958.707"
            y2="1618.263"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1086.311"
            cy="1618.461"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1086.498"
            cy="1656.294"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1068.123"
            y1="1656.294"
            x2="1104.873"
            y2="1656.294"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1086.498"
            cy="1580.044"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1068.123"
            y1="1580.044"
            x2="1104.873"
            y2="1580.044"
          />

          <rect
            x="1044.484"
            y="1599.2"
            transform="matrix(-0.0105 -0.9999 0.9999 -0.0105 -559.5049 2682.6606)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.939"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1170.707"
            y1="1618.076"
            x2="1217.04"
            y2="1618.263"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1148.873,1601.669 1159.873,1617.669 1148.873,1634.669 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1161.873,1601.669 1172.873,1617.669 1161.873,1634.669 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1125.707,1610.336c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1117.874,1613.843,1121.381,1610.336,1125.707,1610.336"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1145.957,1607.356 1152.707,1618.356 1145.832,1628.981 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1105.04"
            y1="1618.075"
            x2="1153.707"
            y2="1618.263"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1216.792,1611.883 1231.722,1620.503 1216.792,1629.123 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			984.207,1899.79 972.207,1883.79 984.207,1866.79 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			971.207,1899.79 959.207,1883.79 971.207,1866.79 		"
          />

          <rect
            x="1029.206"
            y="1864.957"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1047.54,1875.457c4.326,0,7.833,3.507,7.833,7.833s-3.507,7.834-7.833,7.834
			s-7.833-3.508-7.833-7.834S1043.214,1875.457,1047.54,1875.457"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1011.707,1875.457c4.326,0,7.833,3.507,7.833,7.833s-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.508-7.833-7.834S1007.381,1875.457,1011.707,1875.457"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			989.207,1894.103 982.457,1883.103 989.332,1872.478 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1068.04"
            y1="1883.196"
            x2="1101.04"
            y2="1883.383"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="980.707"
            y1="1883.196"
            x2="1030.374"
            y2="1883.383"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="930.04"
            y1="1883.196"
            x2="958.707"
            y2="1883.383"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1086.311"
            cy="1883.582"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1086.498"
            cy="1921.416"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1068.123"
            y1="1921.415"
            x2="1104.873"
            y2="1921.415"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1086.498"
            cy="1845.166"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1068.123"
            y1="1845.165"
            x2="1104.873"
            y2="1845.165"
          />

          <rect
            x="1044.484"
            y="1864.321"
            transform="matrix(-0.0105 -0.9999 0.9999 -0.0105 -824.611 2950.5566)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.939"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1170.707"
            y1="1883.196"
            x2="1217.04"
            y2="1883.383"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1148.873,1866.79 1159.873,1882.79 1148.873,1899.79 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1161.873,1866.79 1172.873,1882.79 1161.873,1899.79 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1125.707,1875.457c4.326,0,7.833,3.507,7.833,7.833s-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.508-7.833-7.834S1121.381,1875.457,1125.707,1875.457"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1145.957,1872.478 1152.707,1883.478 1145.832,1894.103 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1105.04"
            y1="1883.196"
            x2="1153.707"
            y2="1883.383"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1216.792,1877.003 1231.722,1885.623 1216.792,1894.243 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			984.207,2164.91 972.207,2148.91 984.207,2131.91 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			971.207,2164.91 959.207,2148.91 971.207,2131.91 		"
          />

          <rect
            x="1029.206"
            y="2130.077"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1047.54,2140.577c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			s-7.833-3.507-7.833-7.834C1039.707,2144.084,1043.214,2140.577,1047.54,2140.577"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1011.707,2140.577c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1003.874,2144.084,1007.381,2140.577,1011.707,2140.577"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			989.207,2159.223 982.457,2148.223 989.332,2137.598 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1068.04"
            y1="2148.316"
            x2="1101.04"
            y2="2148.504"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="980.707"
            y1="2148.316"
            x2="1030.374"
            y2="2148.504"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="930.04"
            y1="2148.316"
            x2="958.707"
            y2="2148.503"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1086.311"
            cy="2148.703"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1086.498"
            cy="2186.536"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1068.123"
            y1="2186.535"
            x2="1104.873"
            y2="2186.535"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1086.498"
            cy="2110.286"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1068.123"
            y1="2110.285"
            x2="1104.873"
            y2="2110.285"
          />

          <rect
            x="1044.484"
            y="2129.441"
            transform="matrix(-0.0105 -0.9999 0.9999 -0.0105 -1089.717 3218.4526)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.939"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1170.707"
            y1="2148.316"
            x2="1217.04"
            y2="2148.504"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1148.873,2131.91 1159.873,2147.91 1148.873,2164.91 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1161.873,2131.91 1172.873,2147.91 1161.873,2164.91 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1125.707,2140.577c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1117.874,2144.084,1121.381,2140.577,1125.707,2140.577"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1145.957,2137.598 1152.707,2148.598 1145.832,2159.223 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1105.04"
            y1="2148.316"
            x2="1153.707"
            y2="2148.504"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1216.792,2142.124 1231.722,2150.744 1216.792,2159.364 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1322.207,2115.717 1310.207,2099.717 1322.207,2082.717 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1309.207,2115.717 1297.207,2099.717 1309.207,2082.717 		"
          />

          <rect
            x="1367.206"
            y="2080.884"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1385.54,2091.384c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1377.707,2094.891,1381.214,2091.384,1385.54,2091.384"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1349.707,2091.384c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1341.874,2094.891,1345.38,2091.384,1349.707,2091.384"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1327.207,2110.029 1320.457,2099.029 1327.332,2088.404 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1406.04"
            y1="2099.123"
            x2="1439.04"
            y2="2099.311"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1318.707"
            y1="2099.123"
            x2="1368.374"
            y2="2099.311"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1268.04"
            y1="2099.123"
            x2="1296.707"
            y2="2099.31"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1424.311"
            cy="2099.508"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1424.498"
            cy="2137.342"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1406.123"
            y1="2137.342"
            x2="1442.873"
            y2="2137.342"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1424.498"
            cy="2061.092"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1406.123"
            y1="2061.092"
            x2="1442.873"
            y2="2061.092"
          />

          <rect
            x="1382.484"
            y="2080.248"
            transform="matrix(-0.0104 -0.9999 0.9999 -0.0104 -699.0981 3506.5627)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.938"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1508.707"
            y1="2099.123"
            x2="1555.039"
            y2="2099.311"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1486.873,2082.717 1497.873,2098.717 1486.873,2115.717 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1499.873,2082.717 1510.873,2098.717 1499.873,2115.717 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1463.707,2091.384c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1455.874,2094.891,1459.38,2091.384,1463.707,2091.384"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1483.956,2088.404 1490.706,2099.404 1483.831,2110.029 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1443.04"
            y1="2099.123"
            x2="1491.707"
            y2="2099.311"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1554.792,2092.931 1569.722,2101.551 1554.792,2110.17 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1322.207,1966.483 1310.207,1950.483 1322.207,1933.483 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1309.207,1966.483 1297.207,1950.483 1309.207,1933.483 		"
          />

          <rect
            x="1367.206"
            y="1931.649"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1385.54,1942.15c4.326,0,7.833,3.507,7.833,7.832c0,4.327-3.507,7.835-7.833,7.835
			c-4.326,0-7.833-3.508-7.833-7.835C1377.707,1945.657,1381.214,1942.15,1385.54,1942.15"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1349.707,1942.15c4.326,0,7.833,3.507,7.833,7.832c0,4.327-3.507,7.835-7.833,7.835
			c-4.326,0-7.833-3.508-7.833-7.835C1341.874,1945.657,1345.38,1942.15,1349.707,1942.15"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1327.207,1960.796 1320.457,1949.796 1327.332,1939.171 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1406.04"
            y1="1949.89"
            x2="1439.04"
            y2="1950.076"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1318.707"
            y1="1949.89"
            x2="1368.374"
            y2="1950.076"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1268.04"
            y1="1949.889"
            x2="1296.707"
            y2="1950.076"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1424.311"
            cy="1950.275"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1424.498"
            cy="1988.109"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1406.123"
            y1="1988.108"
            x2="1442.873"
            y2="1988.108"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1424.498"
            cy="1911.859"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1406.123"
            y1="1911.858"
            x2="1442.873"
            y2="1911.858"
          />

          <rect
            x="1382.484"
            y="1931.014"
            transform="matrix(-0.0104 -0.9999 0.9999 -0.0104 -549.8722 3355.7783)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.938"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1508.707"
            y1="1949.89"
            x2="1555.039"
            y2="1950.076"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1486.873,1933.483 1497.873,1949.483 1486.873,1966.483 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1499.873,1933.483 1510.873,1949.483 1499.873,1966.483 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1463.707,1942.15c4.326,0,7.833,3.507,7.833,7.832c0,4.327-3.507,7.835-7.833,7.835
			c-4.326,0-7.833-3.508-7.833-7.835C1455.874,1945.657,1459.38,1942.15,1463.707,1942.15"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1483.956,1939.171 1490.706,1950.171 1483.831,1960.796 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1443.04"
            y1="1949.89"
            x2="1491.707"
            y2="1950.076"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1554.792,1943.696 1569.722,1952.316 1554.792,1960.937 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1322.207,1668.016 1310.207,1652.016 1322.207,1635.016 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1309.207,1668.016 1297.207,1652.016 1309.207,1635.016 		"
          />

          <rect
            x="1367.206"
            y="1633.183"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1385.54,1643.683c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1377.707,1647.189,1381.214,1643.683,1385.54,1643.683"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1349.707,1643.683c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1341.874,1647.189,1345.38,1643.683,1349.707,1643.683"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1327.207,1662.328 1320.457,1651.328 1327.332,1640.703 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1406.04"
            y1="1651.422"
            x2="1439.04"
            y2="1651.609"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1318.707"
            y1="1651.422"
            x2="1368.374"
            y2="1651.609"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1268.04"
            y1="1651.422"
            x2="1296.707"
            y2="1651.609"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1424.311"
            cy="1651.808"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1424.498"
            cy="1689.641"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1406.123"
            y1="1689.641"
            x2="1442.873"
            y2="1689.641"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1424.498"
            cy="1613.391"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1406.123"
            y1="1613.391"
            x2="1442.873"
            y2="1613.391"
          />

          <rect
            x="1382.484"
            y="1632.547"
            transform="matrix(-0.0104 -0.9999 0.9999 -0.0104 -251.421 3054.21)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.938"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1508.707"
            y1="1651.422"
            x2="1555.039"
            y2="1651.609"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1486.873,1635.016 1497.873,1651.016 1486.873,1668.016 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1499.873,1635.016 1510.873,1651.016 1499.873,1668.016 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1463.707,1643.683c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1455.874,1647.189,1459.38,1643.683,1463.707,1643.683"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1483.956,1640.703 1490.706,1651.703 1483.831,1662.328 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1443.04"
            y1="1651.422"
            x2="1491.707"
            y2="1651.609"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1554.792,1645.229 1569.722,1653.85 1554.792,1662.47 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1322.207,1518.782 1310.207,1502.782 1322.207,1485.782 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1309.207,1518.782 1297.207,1502.782 1309.207,1485.782 		"
          />

          <rect
            x="1367.206"
            y="1483.949"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.666"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1385.54,1494.449c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1377.707,1497.956,1381.214,1494.449,1385.54,1494.449"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1349.707,1494.449c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1341.874,1497.956,1345.38,1494.449,1349.707,1494.449"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1327.207,1513.095 1320.457,1502.095 1327.332,1491.47 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1406.04"
            y1="1502.188"
            x2="1439.04"
            y2="1502.376"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1318.707"
            y1="1502.188"
            x2="1368.374"
            y2="1502.376"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1268.04"
            y1="1502.188"
            x2="1296.707"
            y2="1502.375"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1424.311"
            cy="1502.575"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1424.498"
            cy="1540.408"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1406.123"
            y1="1540.407"
            x2="1442.873"
            y2="1540.407"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1424.498"
            cy="1464.158"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1406.123"
            y1="1464.157"
            x2="1442.873"
            y2="1464.157"
          />

          <rect
            x="1382.484"
            y="1483.314"
            transform="matrix(-0.0104 -0.9999 0.9999 -0.0104 -102.1957 2903.426)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.938"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1508.707"
            y1="1502.188"
            x2="1555.039"
            y2="1502.376"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1486.873,1485.782 1497.873,1501.782 1486.873,1518.782 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1499.873,1485.782 1510.873,1501.782 1499.873,1518.782 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1463.707,1494.449c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1455.874,1497.956,1459.38,1494.449,1463.707,1494.449"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1483.956,1491.47 1490.706,1502.47 1483.831,1513.095 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1443.04"
            y1="1502.188"
            x2="1491.707"
            y2="1502.376"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1554.792,1495.996 1569.722,1504.616 1554.792,1513.236 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1658.102,1462.135 1646.102,1446.135 1658.102,1429.135 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1645.102,1462.135 1633.102,1446.135 1645.102,1429.135 		"
          />

          <rect
            x="1703.101"
            y="1427.302"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1721.435,1437.802c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1713.602,1441.309,1717.109,1437.802,1721.435,1437.802"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1685.602,1437.802c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			s-7.833-3.507-7.833-7.834C1677.769,1441.309,1681.275,1437.802,1685.602,1437.802"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1663.102,1456.447 1656.352,1445.447 1663.227,1434.822 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1741.935"
            y1="1445.541"
            x2="1774.935"
            y2="1445.729"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1654.602"
            y1="1445.541"
            x2="1704.269"
            y2="1445.729"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1603.935"
            y1="1445.541"
            x2="1632.602"
            y2="1445.728"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1760.206"
            cy="1445.927"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1760.393"
            cy="1483.76"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1742.018"
            y1="1483.76"
            x2="1778.768"
            y2="1483.76"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1760.393"
            cy="1407.51"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1742.018"
            y1="1407.51"
            x2="1778.768"
            y2="1407.51"
          />

          <rect
            x="1718.379"
            y="1426.666"
            transform="matrix(-0.0104 -0.9999 0.9999 -0.0104 293.8337 3182.0669)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.938"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1844.602"
            y1="1445.541"
            x2="1890.935"
            y2="1445.729"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1822.768,1429.135 1833.768,1445.135 1822.768,1462.135 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1835.768,1429.135 1846.768,1445.135 1835.768,1462.135 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1799.602,1437.802c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			s-7.833-3.507-7.833-7.834C1791.769,1441.309,1795.275,1437.802,1799.602,1437.802"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1819.852,1434.822 1826.602,1445.822 1819.727,1456.447 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1778.935"
            y1="1445.541"
            x2="1827.602"
            y2="1445.729"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1890.688,1439.349 1905.617,1447.969 1890.688,1456.589 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1658.102,1757.349 1646.102,1741.349 1658.102,1724.349 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1645.102,1757.349 1633.102,1741.349 1645.102,1724.349 		"
          />

          <rect
            x="1703.101"
            y="1722.515"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1721.435,1733.016c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1713.602,1736.522,1717.109,1733.016,1721.435,1733.016"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1685.602,1733.016c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			s-7.833-3.507-7.833-7.834C1677.769,1736.522,1681.275,1733.016,1685.602,1733.016"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1663.102,1751.661 1656.352,1740.661 1663.227,1730.036 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1741.935"
            y1="1740.755"
            x2="1774.935"
            y2="1740.942"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1654.602"
            y1="1740.755"
            x2="1704.269"
            y2="1740.942"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1603.935"
            y1="1740.755"
            x2="1632.602"
            y2="1740.941"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1760.206"
            cy="1741.14"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1760.393"
            cy="1778.974"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1742.018"
            y1="1778.974"
            x2="1778.768"
            y2="1778.974"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1760.393"
            cy="1702.724"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1742.018"
            y1="1702.724"
            x2="1778.768"
            y2="1702.724"
          />

          <rect
            x="1718.379"
            y="1721.88"
            transform="matrix(-0.0104 -0.9999 0.9999 -0.0104 -1.3643 3480.3479)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.938"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1844.602"
            y1="1740.755"
            x2="1890.935"
            y2="1740.942"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1822.768,1724.349 1833.768,1740.349 1822.768,1757.349 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1835.768,1724.349 1846.768,1740.349 1835.768,1757.349 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1799.602,1733.016c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			s-7.833-3.507-7.833-7.834C1791.769,1736.522,1795.275,1733.016,1799.602,1733.016"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1819.852,1730.036 1826.602,1741.036 1819.727,1751.661 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1778.935"
            y1="1740.755"
            x2="1827.602"
            y2="1740.942"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1890.688,1734.563 1905.617,1743.182 1890.688,1751.802 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1658.102,1904.955 1646.102,1888.955 1658.102,1871.955 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1645.102,1904.955 1633.102,1888.955 1645.102,1871.955 		"
          />

          <rect
            x="1703.101"
            y="1870.122"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1721.435,1880.622c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1713.602,1884.129,1717.109,1880.622,1721.435,1880.622"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1685.602,1880.622c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			s-7.833-3.507-7.833-7.834C1677.769,1884.129,1681.275,1880.622,1685.602,1880.622"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1663.102,1899.268 1656.352,1888.268 1663.227,1877.643 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1741.935"
            y1="1888.361"
            x2="1774.935"
            y2="1888.549"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1654.602"
            y1="1888.361"
            x2="1704.269"
            y2="1888.549"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1603.935"
            y1="1888.361"
            x2="1632.602"
            y2="1888.549"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1760.206"
            cy="1888.748"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1760.393"
            cy="1926.581"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1742.018"
            y1="1926.58"
            x2="1778.768"
            y2="1926.58"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1760.393"
            cy="1850.331"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1742.018"
            y1="1850.33"
            x2="1778.768"
            y2="1850.33"
          />

          <rect
            x="1718.379"
            y="1869.487"
            transform="matrix(-0.0104 -0.9999 0.9999 -0.0104 -148.9628 3629.488)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.938"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1844.602"
            y1="1888.361"
            x2="1890.935"
            y2="1888.549"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1822.768,1871.955 1833.768,1887.955 1822.768,1904.955 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1835.768,1871.955 1846.768,1887.955 1835.768,1904.955 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1799.602,1880.622c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			s-7.833-3.507-7.833-7.834C1791.769,1884.129,1795.275,1880.622,1799.602,1880.622"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1819.852,1877.643 1826.602,1888.643 1819.727,1899.268 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1778.935"
            y1="1888.361"
            x2="1827.602"
            y2="1888.549"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1890.688,1882.169 1905.617,1890.789 1890.688,1899.409 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1658.102,2052.563 1646.102,2036.563 1658.102,2019.563 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1645.102,2052.563 1633.102,2036.563 1645.102,2019.563 		"
          />

          <rect
            x="1703.101"
            y="2017.729"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1721.435,2028.229c4.326,0,7.833,3.507,7.833,7.833s-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.508-7.833-7.834S1717.109,2028.229,1721.435,2028.229"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1685.602,2028.229c4.326,0,7.833,3.507,7.833,7.833s-3.507,7.834-7.833,7.834
			s-7.833-3.508-7.833-7.834S1681.275,2028.229,1685.602,2028.229"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1663.102,2046.875 1656.352,2035.875 1663.227,2025.25 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1741.935"
            y1="2035.969"
            x2="1774.935"
            y2="2036.155"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1654.602"
            y1="2035.969"
            x2="1704.269"
            y2="2036.155"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1603.935"
            y1="2035.969"
            x2="1632.602"
            y2="2036.155"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1760.206"
            cy="2036.354"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1760.393"
            cy="2074.188"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1742.018"
            y1="2074.188"
            x2="1778.768"
            y2="2074.188"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1760.393"
            cy="1997.938"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1742.018"
            y1="1997.938"
            x2="1778.768"
            y2="1997.938"
          />

          <rect
            x="1718.379"
            y="2017.094"
            transform="matrix(-0.0104 -0.9999 0.9999 -0.0104 -296.5616 3778.6287)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.938"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1844.602"
            y1="2035.969"
            x2="1890.935"
            y2="2036.155"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1822.768,2019.563 1833.768,2035.563 1822.768,2052.563 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1835.768,2019.563 1846.768,2035.563 1835.768,2052.563 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1799.602,2028.229c4.326,0,7.833,3.507,7.833,7.833s-3.507,7.834-7.833,7.834
			s-7.833-3.508-7.833-7.834S1795.275,2028.229,1799.602,2028.229"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1819.852,2025.25 1826.602,2036.25 1819.727,2046.875 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1778.935"
            y1="2035.969"
            x2="1827.602"
            y2="2036.155"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1890.688,2029.775 1905.617,2038.396 1890.688,2047.016 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1658.102,2200.169 1646.102,2184.169 1658.102,2167.169 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1645.102,2200.169 1633.102,2184.169 1645.102,2167.169 		"
          />

          <rect
            x="1703.101"
            y="2165.336"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1721.435,2175.836c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1713.602,2179.343,1717.109,2175.836,1721.435,2175.836"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1685.602,2175.836c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			s-7.833-3.507-7.833-7.834C1677.769,2179.343,1681.275,2175.836,1685.602,2175.836"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1663.102,2194.481 1656.352,2183.481 1663.227,2172.856 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1741.935"
            y1="2183.575"
            x2="1774.935"
            y2="2183.763"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1654.602"
            y1="2183.575"
            x2="1704.269"
            y2="2183.763"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1603.935"
            y1="2183.575"
            x2="1632.602"
            y2="2183.762"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1760.206"
            cy="2183.961"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1760.393"
            cy="2221.794"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1742.018"
            y1="2221.794"
            x2="1778.768"
            y2="2221.794"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1760.393"
            cy="2145.544"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1742.018"
            y1="2145.544"
            x2="1778.768"
            y2="2145.544"
          />

          <rect
            x="1718.379"
            y="2164.7"
            transform="matrix(-0.0104 -0.9999 0.9999 -0.0104 -444.1606 3927.769)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.938"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1844.602"
            y1="2183.575"
            x2="1890.935"
            y2="2183.763"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1822.768,2167.169 1833.768,2183.169 1822.768,2200.169 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1835.768,2167.169 1846.768,2183.169 1835.768,2200.169 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1799.602,2175.836c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			s-7.833-3.507-7.833-7.834C1791.769,2179.343,1795.275,2175.836,1799.602,2175.836"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1819.852,2172.856 1826.602,2183.856 1819.727,2194.481 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1778.935"
            y1="2183.575"
            x2="1827.602"
            y2="2183.763"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1890.688,2177.383 1905.617,2186.003 1890.688,2194.623 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1322.207,1369.549 1310.207,1353.549 1322.207,1336.549 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1309.207,1369.549 1297.207,1353.549 1309.207,1336.549 		"
          />

          <rect
            x="1367.206"
            y="1334.716"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1385.54,1345.216c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1377.707,1348.723,1381.214,1345.216,1385.54,1345.216"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1349.707,1345.216c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1341.874,1348.723,1345.38,1345.216,1349.707,1345.216"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1327.207,1363.861 1320.457,1352.861 1327.332,1342.236 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1406.04"
            y1="1352.955"
            x2="1439.04"
            y2="1353.143"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1318.707"
            y1="1352.955"
            x2="1368.374"
            y2="1353.143"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1268.04"
            y1="1352.955"
            x2="1296.707"
            y2="1353.142"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1424.311"
            cy="1353.34"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1424.498"
            cy="1391.174"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1406.123"
            y1="1391.174"
            x2="1442.873"
            y2="1391.174"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1424.498"
            cy="1314.924"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1406.123"
            y1="1314.924"
            x2="1442.873"
            y2="1314.924"
          />

          <rect
            x="1382.484"
            y="1334.08"
            transform="matrix(-0.0104 -0.9999 0.9999 -0.0104 47.0302 2752.6416)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.938"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1508.707"
            y1="1352.955"
            x2="1555.039"
            y2="1353.143"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1486.873,1336.549 1497.873,1352.549 1486.873,1369.549 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1499.873,1336.549 1510.873,1352.549 1499.873,1369.549 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M1463.707,1345.216c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1455.874,1348.723,1459.38,1345.216,1463.707,1345.216"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1483.956,1342.236 1490.706,1353.236 1483.831,1363.861 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1443.04"
            y1="1352.955"
            x2="1491.707"
            y2="1353.143"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1554.792,1346.763 1569.722,1355.383 1554.792,1364.002 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2247.207,1314.528 2235.207,1298.528 2247.207,1281.528 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2234.207,1314.528 2222.207,1298.528 2234.207,1281.528 		"
          />

          <rect
            x="2292.206"
            y="1279.695"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2310.54,1290.195c4.326,0,7.833,3.507,7.833,7.832c0,4.327-3.507,7.835-7.833,7.835
			s-7.833-3.508-7.833-7.835C2302.707,1293.702,2306.214,1290.195,2310.54,1290.195"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2274.707,1290.195c4.325,0,7.832,3.507,7.832,7.832c0,4.327-3.507,7.835-7.832,7.835
			c-4.326,0-7.834-3.508-7.834-7.835C2266.873,1293.702,2270.381,1290.195,2274.707,1290.195"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2252.207,1308.841 2245.457,1297.841 2252.332,1287.216 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2331.04"
            y1="1297.935"
            x2="2364.04"
            y2="1298.121"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2243.707"
            y1="1297.935"
            x2="2293.374"
            y2="1298.121"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2193.04"
            y1="1297.934"
            x2="2221.707"
            y2="1298.121"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2349.311"
            cy="1298.32"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2349.498"
            cy="1336.153"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2331.123"
            y1="1336.153"
            x2="2367.873"
            y2="1336.153"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2349.498"
            cy="1259.903"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2331.123"
            y1="1259.903"
            x2="2367.873"
            y2="1259.903"
          />

          <rect
            x="2307.484"
            y="1279.059"
            transform="matrix(-0.0105 -0.9999 0.9999 -0.0105 1036.8401 3622.0994)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.939"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2433.707"
            y1="1297.935"
            x2="2480.039"
            y2="1298.121"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2411.873,1281.528 2422.873,1297.528 2411.873,1314.528 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2424.873,1281.528 2435.873,1297.528 2424.873,1314.528 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2388.707,1290.195c4.325,0,7.832,3.507,7.832,7.832c0,4.327-3.507,7.835-7.832,7.835
			c-4.326,0-7.834-3.508-7.834-7.835C2380.873,1293.702,2384.381,1290.195,2388.707,1290.195"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2408.957,1287.216 2415.707,1298.216 2408.832,1308.841 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2368.04"
            y1="1297.935"
            x2="2416.707"
            y2="1298.121"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2479.792,1291.741 2494.723,1300.361 2479.792,1308.981 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2885.207,1899.79 2873.207,1883.79 2885.207,1866.79 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2872.207,1899.79 2860.207,1883.79 2872.207,1866.79 		"
          />

          <rect
            x="2930.206"
            y="1864.957"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2948.54,1875.457c4.326,0,7.833,3.507,7.833,7.833s-3.507,7.834-7.833,7.834
			s-7.833-3.508-7.833-7.834S2944.214,1875.457,2948.54,1875.457"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2912.707,1875.457c4.325,0,7.832,3.507,7.832,7.833s-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.508-7.834-7.834S2908.381,1875.457,2912.707,1875.457"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2890.207,1894.103 2883.457,1883.103 2890.332,1872.478 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2969.04"
            y1="1883.196"
            x2="3002.04"
            y2="1883.383"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2881.707"
            y1="1883.196"
            x2="2931.374"
            y2="1883.383"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2831.04"
            y1="1883.196"
            x2="2859.707"
            y2="1883.383"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2987.311"
            cy="1883.582"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2987.498"
            cy="1921.416"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2969.123"
            y1="1921.415"
            x2="3005.873"
            y2="1921.415"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2987.498"
            cy="1845.166"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2969.123"
            y1="1845.165"
            x2="3005.873"
            y2="1845.165"
          />

          <rect
            x="2945.484"
            y="1864.321"
            transform="matrix(-0.0105 -0.9999 0.9999 -0.0105 1096.2892 4851.4521)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.939"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="3071.707"
            y1="1883.196"
            x2="3118.039"
            y2="1883.383"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3049.873,1866.79 3060.873,1882.79 3049.873,1899.79 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3062.873,1866.79 3073.873,1882.79 3062.873,1899.79 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M3026.707,1875.457c4.325,0,7.832,3.507,7.832,7.833s-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.508-7.834-7.834S3022.381,1875.457,3026.707,1875.457"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3046.957,1872.478 3053.707,1883.478 3046.832,1894.103 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="3006.04"
            y1="1883.196"
            x2="3054.707"
            y2="1883.383"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3117.792,1877.003 3132.723,1885.623 3117.792,1894.243 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2885.207,2164.91 2873.207,2148.91 2885.207,2131.91 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2872.207,2164.91 2860.207,2148.91 2872.207,2131.91 		"
          />

          <rect
            x="2930.206"
            y="2130.077"
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2948.54,2140.577c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			s-7.833-3.507-7.833-7.834C2940.707,2144.084,2944.214,2140.577,2948.54,2140.577"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M2912.707,2140.577c4.325,0,7.832,3.507,7.832,7.833c0,4.327-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.507-7.834-7.834C2904.873,2144.084,2908.381,2140.577,2912.707,2140.577"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2890.207,2159.223 2883.457,2148.223 2890.332,2137.598 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2969.04"
            y1="2148.316"
            x2="3002.04"
            y2="2148.504"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2881.707"
            y1="2148.316"
            x2="2931.374"
            y2="2148.504"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2831.04"
            y1="2148.316"
            x2="2859.707"
            y2="2148.503"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2987.311"
            cy="2148.703"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2987.498"
            cy="2186.536"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2969.123"
            y1="2186.535"
            x2="3005.873"
            y2="2186.535"
          />

          <circle
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2987.498"
            cy="2110.286"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2969.123"
            y1="2110.285"
            x2="3005.873"
            y2="2110.285"
          />

          <rect
            x="2945.484"
            y="2129.441"
            transform="matrix(-0.0105 -0.9999 0.9999 -0.0105 831.1831 5119.3486)"
            style="clip-path:url(#SVGID_2_);"
            width="6.25"
            height="37.939"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="3071.707"
            y1="2148.316"
            x2="3118.039"
            y2="2148.504"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3049.873,2131.91 3060.873,2147.91 3049.873,2164.91 		"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3062.873,2131.91 3073.873,2147.91 3062.873,2164.91 		"
          />
          <path
            style="clip-path:url(#SVGID_2_);"
            d="M3026.707,2140.577c4.325,0,7.832,3.507,7.832,7.833c0,4.327-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.507-7.834-7.834C3018.873,2144.084,3022.381,2140.577,3026.707,2140.577"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3046.957,2137.598 3053.707,2148.598 3046.832,2159.223 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="3006.04"
            y1="2148.316"
            x2="3054.707"
            y2="2148.504"
          />
          <polygon
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3117.792,2142.124 3132.723,2150.744 3117.792,2159.364 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="927.504"
            y1="1225.32"
            x2="931.504"
            y2="2314.814"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1265.505"
            y1="1225.32"
            x2="1269.505"
            y2="2314.814"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1601.488"
            y1="1225.32"
            x2="1605.488"
            y2="2314.814"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2184.959"
            y1="1225.32"
            x2="2188.959"
            y2="2314.814"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2505.942"
            y1="1225.32"
            x2="2509.942"
            y2="2314.814"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2829.927"
            y1="1225.32"
            x2="2833.927"
            y2="2314.814"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1965.505,1226.32 1965.505,1897.32 2077.505,1897.32 2077.505,1477.32 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2077.889"
            y1="1302.32"
            x2="2077.889"
            y2="1228.32"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;"
            points="
			1149.505,869.32 1152.755,872.82 1156.005,869.32 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;"
            x1="1152.755"
            y1="872.82"
            x2="1152.755"
            y2="877.07"
          />
          <polyline
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;"
            points="
			1149.505,841.57 1152.755,845.07 1156.005,841.57 		"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;"
            x1="1152.755"
            y1="845.07"
            x2="1152.755"
            y2="849.32"
          />

          <line
            style="clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1153.505"
            y1="871.32"
            x2="1227.505"
            y2="871.32"
          />
        </g>
        <text
          transform="matrix(1 0 0 1 746.0049 326.7607)"
          style="font-family:'AdobeHeitiStd-Regular-GBpc-EUC-H'; font-size:17.1667px;"
        >进线柜</text>
        <text
          transform="matrix(1 0 0 1 227.0049 1197.7344)"
          style="font-family:'AdobeHeitiStd-Regular-GBpc-EUC-H'; font-size:28.5px;"
        >T11</text>
        <text
          transform="matrix(1 0 0 1 377.0005 1197.7344)"
          style="font-family:'AdobeHeitiStd-Regular-GBpc-EUC-H'; font-size:28.5px;"
        >T12</text>
        <text
          transform="matrix(1 0 0 1 603.0054 1197.7344)"
          style="font-family:'AdobeHeitiStd-Regular-GBpc-EUC-H'; font-size:28.5px;"
        >T13</text>
        <text
          transform="matrix(1 0 0 1 829.0103 1197.7344)"
          style="font-family:'AdobeHeitiStd-Regular-GBpc-EUC-H'; font-size:28.5px;"
        >T14</text>
        <text
          transform="matrix(1 0 0 1 1055.0156 1197.7344)"
          style="font-family:'AdobeHeitiStd-Regular-GBpc-EUC-H'; font-size:28.5px;"
        >T15</text>
        <text
          transform="matrix(1 0 0 1 1389.0068 1197.7344)"
          style="font-family:'AdobeHeitiStd-Regular-GBpc-EUC-H'; font-size:28.5px;"
        >T16</text>
        <text
          transform="matrix(1 0 0 1 1728.0146 1197.7344)"
          style="font-family:'AdobeHeitiStd-Regular-GBpc-EUC-H'; font-size:28.5px;"
        >T17</text>
        <text
          transform="matrix(1 0 0 1 2053.0283 1197.7344)"
          style="font-family:'AdobeHeitiStd-Regular-GBpc-EUC-H'; font-size:28.5px;"
        >T18</text>
        <text
          transform="matrix(1 0 0 1 2308.0176 1197.7344)"
          style="font-family:'AdobeHeitiStd-Regular-GBpc-EUC-H'; font-size:28.5px;"
        >T27</text>
        <text
          transform="matrix(1 0 0 1 2641.0117 1197.7344)"
          style="font-family:'AdobeHeitiStd-Regular-GBpc-EUC-H'; font-size:28.5px;"
        >T26</text>
        <text
          transform="matrix(1 0 0 1 2961.0098 1197.7344)"
          style="font-family:'AdobeHeitiStd-Regular-GBpc-EUC-H'; font-size:28.5px;"
        >T25</text>
        <text
          transform="matrix(1 0 0 1 3207.0215 1197.7344)"
          style="font-family:'AdobeHeitiStd-Regular-GBpc-EUC-H'; font-size:28.5px;"
        >T24</text>
        <text
          transform="matrix(1 0 0 1 3382.0117 1197.7344)"
          style="font-family:'AdobeHeitiStd-Regular-GBpc-EUC-H'; font-size:28.5px;"
        >T23</text>
        <text
          transform="matrix(1 0 0 1 3592 1197.7344)"
          style="font-family:'AdobeHeitiStd-Regular-GBpc-EUC-H'; font-size:28.5px;"
        >T22</text>
        <text
          transform="matrix(1 0 0 1 3771.0078 1197.7344)"
          style="font-family:'AdobeHeitiStd-Regular-GBpc-EUC-H'; font-size:28.5px;"
        >T21</text>

        <text
          transform="matrix(1 0 0 1 1013.5049 326.7607)"
          style="font-family:'AdobeHeitiStd-Regular-GBpc-EUC-H'; font-size:17.1667px;"
        >计量柜</text>
        <text
          transform="matrix(1 0 0 1 1466.002 326.7607)"
          style="font-family:'AdobeHeitiStd-Regular-GBpc-EUC-H'; font-size:17.1667px;"
        >压电避雷器柜</text>

        <text
          transform="matrix(1 0 0 1 1857.0078 326.7607)"
          style="font-family:'AdobeHeitiStd-Regular-GBpc-EUC-H'; font-size:17.1667px;"
        >1#出线柜</text>

        <text
          transform="matrix(1 0 0 1 2746.5176 326.7607)"
          style="font-family:'AdobeHeitiStd-Regular-GBpc-EUC-H'; font-size:17.1667px;"
        >2#出线柜</text>

        <text
          transform="matrix(1 0 0 1 3359.5234 739.7573)"
          style="font-family:'AdobeHeitiStd-Regular-GBpc-EUC-H'; font-size:17.1667px;"
        >2号主变</text>

        <text
          transform="matrix(1 0 0 1 2459.5244 739.7573)"
          style="font-family:'AdobeHeitiStd-Regular-GBpc-EUC-H'; font-size:17.1667px;"
        >1号主变</text>

        <text
          transform="matrix(1 0 0 1 458.5054 2185.7598)"
          style="font-family:'AdobeHeitiStd-Regular-GBpc-EUC-H'; font-size:17.1667px;"
        >电容补偿</text>

        <text
          transform="matrix(1 0 0 1 682.5137 2185.7598)"
          style="font-family:'AdobeHeitiStd-Regular-GBpc-EUC-H'; font-size:17.1667px;"
        >电容补偿</text>

        <text
          transform="matrix(1 0 0 1 3460.5156 2185.7598)"
          style="font-family:'AdobeHeitiStd-Regular-GBpc-EUC-H'; font-size:17.1667px;"
        >电容补偿</text>

        <text
          transform="matrix(1 0 0 1 3666.5156 2185.7598)"
          style="font-family:'AdobeHeitiStd-Regular-GBpc-EUC-H'; font-size:17.1667px;"
        >电容补偿</text>
        <g>
          <defs>
            <rect id="SVGID_3_" x="0.001" y="25.467" width="4077.408" height="2573.926" />
          </defs>
          <clipPath id="SVGID_4_">
            <use xlink:href="#SVGID_3_" style="overflow:visible;" />
          </clipPath>
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2884.208,1395.012 2872.208,1379.012 2884.208,1362.012 		"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2871.208,1395.012 2859.208,1379.012 2871.208,1362.012 		"
          />

          <rect
            x="2929.207"
            y="1360.179"
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_4_);"
            d="M2947.541,1370.679c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			s-7.833-3.507-7.833-7.834C2939.708,1374.186,2943.215,1370.679,2947.541,1370.679"
          />
          <path
            style="clip-path:url(#SVGID_4_);"
            d="M2911.708,1370.679c4.325,0,7.832,3.507,7.832,7.833c0,4.327-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.507-7.834-7.834C2903.874,1374.186,2907.382,1370.679,2911.708,1370.679"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			2889.208,1389.324 2882.458,1378.324 2889.333,1367.699 		"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2968.041"
            y1="1378.418"
            x2="3001.041"
            y2="1378.605"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2880.708"
            y1="1378.418"
            x2="2930.375"
            y2="1378.605"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="2830.041"
            y1="1378.418"
            x2="2858.708"
            y2="1378.604"
          />

          <circle
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2986.312"
            cy="1378.803"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2986.499"
            cy="1416.637"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2968.124"
            y1="1416.637"
            x2="3004.874"
            y2="1416.637"
          />

          <circle
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="2986.499"
            cy="1340.387"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="2968.124"
            y1="1340.387"
            x2="3004.874"
            y2="1340.387"
          />

          <rect
            x="2944.485"
            y="1359.542"
            transform="matrix(0.9999 -0.0105 0.0105 0.9999 -14.269 30.9316)"
            style="clip-path:url(#SVGID_4_);"
            width="6.25"
            height="37.939"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="3070.708"
            y1="1378.418"
            x2="3117.04"
            y2="1378.605"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3048.874,1362.012 3059.874,1378.012 3048.874,1395.012 		"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3061.874,1362.012 3072.874,1378.012 3061.874,1395.012 		"
          />
          <path
            style="clip-path:url(#SVGID_4_);"
            d="M3025.708,1370.679c4.325,0,7.832,3.507,7.832,7.833c0,4.327-3.507,7.834-7.832,7.834
			c-4.326,0-7.834-3.507-7.834-7.834C3017.874,1374.186,3021.382,1370.679,3025.708,1370.679"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3045.958,1367.699 3052.708,1378.699 3045.833,1389.324 		"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="3005.041"
            y1="1378.418"
            x2="3053.708"
            y2="1378.605"
          />
          <polygon
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			3116.793,1372.226 3131.724,1380.846 3116.793,1389.465 		"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1657.208,1339.991 1645.208,1323.991 1657.208,1306.991 		"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1644.208,1339.991 1632.208,1323.991 1644.208,1306.991 		"
          />

          <rect
            x="1702.207"
            y="1305.158"
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.666"
          />
          <path
            style="clip-path:url(#SVGID_4_);"
            d="M1720.541,1315.658c4.326,0,7.833,3.507,7.833,7.832c0,4.327-3.507,7.835-7.833,7.835
			s-7.833-3.508-7.833-7.835C1712.708,1319.165,1716.215,1315.658,1720.541,1315.658"
          />
          <path
            style="clip-path:url(#SVGID_4_);"
            d="M1684.708,1315.658c4.326,0,7.833,3.507,7.833,7.832c0,4.327-3.507,7.835-7.833,7.835
			c-4.326,0-7.833-3.508-7.833-7.835C1676.875,1319.165,1680.382,1315.658,1684.708,1315.658"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1662.208,1334.304 1655.458,1323.304 1662.333,1312.679 		"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1741.041"
            y1="1323.397"
            x2="1774.041"
            y2="1323.584"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1653.708"
            y1="1323.397"
            x2="1703.375"
            y2="1323.584"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1603.041"
            y1="1323.396"
            x2="1631.708"
            y2="1323.584"
          />

          <circle
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1759.312"
            cy="1323.783"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1759.499"
            cy="1361.617"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1741.124"
            y1="1361.616"
            x2="1777.874"
            y2="1361.616"
          />

          <circle
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1759.499"
            cy="1285.366"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1741.124"
            y1="1285.366"
            x2="1777.874"
            y2="1285.366"
          />

          <rect
            x="1717.485"
            y="1304.522"
            transform="matrix(0.9999 -0.0103 0.0103 0.9999 -13.5564 17.8131)"
            style="clip-path:url(#SVGID_4_);"
            width="6.25"
            height="37.938"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1843.708"
            y1="1323.397"
            x2="1890.041"
            y2="1323.584"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1821.874,1306.991 1832.874,1322.991 1821.874,1339.991 		"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1834.874,1306.991 1845.874,1322.991 1834.874,1339.991 		"
          />
          <path
            style="clip-path:url(#SVGID_4_);"
            d="M1798.708,1315.658c4.326,0,7.833,3.507,7.833,7.832c0,4.327-3.507,7.835-7.833,7.835
			c-4.326,0-7.833-3.508-7.833-7.835C1790.875,1319.165,1794.382,1315.658,1798.708,1315.658"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1818.958,1312.679 1825.708,1323.679 1818.833,1334.304 		"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1778.041"
            y1="1323.397"
            x2="1826.708"
            y2="1323.584"
          />
          <polygon
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1889.793,1317.204 1904.723,1325.824 1889.793,1334.444 		"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			982.172,1395.012 970.172,1379.012 982.172,1362.012 		"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			969.172,1395.012 957.172,1379.012 969.172,1362.012 		"
          />

          <rect
            x="1027.172"
            y="1360.179"
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_4_);"
            d="M1045.506,1370.679c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1037.673,1374.186,1041.18,1370.679,1045.506,1370.679"
          />
          <path
            style="clip-path:url(#SVGID_4_);"
            d="M1009.672,1370.679c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1001.839,1374.186,1005.346,1370.679,1009.672,1370.679"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			987.172,1389.324 980.422,1378.324 987.297,1367.699 		"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1066.006"
            y1="1378.418"
            x2="1099.006"
            y2="1378.605"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="978.672"
            y1="1378.418"
            x2="1028.339"
            y2="1378.605"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="928.005"
            y1="1378.418"
            x2="956.672"
            y2="1378.604"
          />

          <circle
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1084.276"
            cy="1378.803"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1084.464"
            cy="1416.637"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1066.089"
            y1="1416.637"
            x2="1102.839"
            y2="1416.637"
          />

          <circle
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1084.464"
            cy="1340.387"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1066.089"
            y1="1340.387"
            x2="1102.839"
            y2="1340.387"
          />

          <rect
            x="1042.45"
            y="1359.542"
            transform="matrix(0.9999 -0.0105 0.0105 0.9999 -14.3733 11.0209)"
            style="clip-path:url(#SVGID_4_);"
            width="6.25"
            height="37.939"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1168.672"
            y1="1378.418"
            x2="1215.005"
            y2="1378.605"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1146.839,1362.012 1157.839,1378.012 1146.839,1395.012 		"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1159.839,1362.012 1170.839,1378.012 1159.839,1395.012 		"
          />
          <path
            style="clip-path:url(#SVGID_4_);"
            d="M1123.672,1370.679c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1115.839,1374.186,1119.346,1370.679,1123.672,1370.679"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1143.922,1367.699 1150.672,1378.699 1143.797,1389.324 		"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1103.006"
            y1="1378.418"
            x2="1151.673"
            y2="1378.605"
          />
          <polygon
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1214.758,1372.226 1229.688,1380.846 1214.758,1389.465 		"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1657.208,1635.205 1645.208,1619.205 1657.208,1602.205 		"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1644.208,1635.205 1632.208,1619.205 1644.208,1602.205 		"
          />

          <rect
            x="1702.207"
            y="1600.371"
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.666"
          />
          <path
            style="clip-path:url(#SVGID_4_);"
            d="M1720.541,1610.871c4.326,0,7.833,3.508,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			s-7.833-3.507-7.833-7.834C1712.708,1614.379,1716.215,1610.871,1720.541,1610.871"
          />
          <path
            style="clip-path:url(#SVGID_4_);"
            d="M1684.708,1610.871c4.326,0,7.833,3.508,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1676.875,1614.379,1680.382,1610.871,1684.708,1610.871"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1662.208,1629.518 1655.458,1618.518 1662.333,1607.893 		"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1741.041"
            y1="1618.611"
            x2="1774.041"
            y2="1618.798"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1653.708"
            y1="1618.611"
            x2="1703.375"
            y2="1618.798"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1603.041"
            y1="1618.61"
            x2="1631.708"
            y2="1618.798"
          />

          <circle
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1759.312"
            cy="1618.997"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1759.499"
            cy="1656.83"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1741.124"
            y1="1656.83"
            x2="1777.874"
            y2="1656.83"
          />

          <circle
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1759.499"
            cy="1580.58"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1741.124"
            y1="1580.58"
            x2="1777.874"
            y2="1580.58"
          />

          <rect
            x="1717.485"
            y="1599.736"
            transform="matrix(0.9999 -0.0103 0.0103 0.9999 -16.6006 17.8289)"
            style="clip-path:url(#SVGID_4_);"
            width="6.25"
            height="37.938"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1843.708"
            y1="1618.611"
            x2="1890.041"
            y2="1618.798"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1821.874,1602.205 1832.874,1618.205 1821.874,1635.205 		"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1834.874,1602.205 1845.874,1618.205 1834.874,1635.205 		"
          />
          <path
            style="clip-path:url(#SVGID_4_);"
            d="M1798.708,1610.871c4.326,0,7.833,3.508,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1790.875,1614.379,1794.382,1610.871,1798.708,1610.871"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1818.958,1607.893 1825.708,1618.893 1818.833,1629.518 		"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1778.041"
            y1="1618.611"
            x2="1826.708"
            y2="1618.798"
          />
          <polygon
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1889.793,1612.418 1904.723,1621.038 1889.793,1629.658 		"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1322.208,1842.713 1310.208,1826.713 1322.208,1809.713 		"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1309.208,1842.713 1297.208,1826.713 1309.208,1809.713 		"
          />

          <rect
            x="1367.207"
            y="1807.879"
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="36.667"
            height="36.667"
          />
          <path
            style="clip-path:url(#SVGID_4_);"
            d="M1385.541,1818.379c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1377.708,1821.886,1381.215,1818.379,1385.541,1818.379"
          />
          <path
            style="clip-path:url(#SVGID_4_);"
            d="M1349.708,1818.379c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1341.875,1821.886,1345.381,1818.379,1349.708,1818.379"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1327.208,1837.025 1320.458,1826.025 1327.333,1815.4 		"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1406.041"
            y1="1826.119"
            x2="1439.041"
            y2="1826.306"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1318.708"
            y1="1826.119"
            x2="1368.375"
            y2="1826.306"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1268.041"
            y1="1826.118"
            x2="1296.708"
            y2="1826.306"
          />

          <circle
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1424.312"
            cy="1826.504"
            r="14.333"
          />

          <circle
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1424.499"
            cy="1864.337"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1406.124"
            y1="1864.338"
            x2="1442.874"
            y2="1864.338"
          />

          <circle
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            cx="1424.499"
            cy="1788.087"
            r="14.333"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            x1="1406.124"
            y1="1788.088"
            x2="1442.874"
            y2="1788.088"
          />

          <rect
            x="1382.485"
            y="1807.244"
            transform="matrix(0.9999 -0.0103 0.0103 0.9999 -18.7582 14.3854)"
            style="clip-path:url(#SVGID_4_);"
            width="6.25"
            height="37.938"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1508.708"
            y1="1826.119"
            x2="1555.04"
            y2="1826.306"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1486.874,1809.713 1497.874,1825.713 1486.874,1842.713 		"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1499.874,1809.713 1510.874,1825.713 1499.874,1842.713 		"
          />
          <path
            style="clip-path:url(#SVGID_4_);"
            d="M1463.708,1818.379c4.326,0,7.833,3.507,7.833,7.833c0,4.327-3.507,7.834-7.833,7.834
			c-4.326,0-7.833-3.507-7.833-7.834C1455.875,1821.886,1459.381,1818.379,1463.708,1818.379"
          />
          <polyline
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1483.957,1815.4 1490.707,1826.4 1483.832,1837.025 		"
          />

          <line
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="1443.041"
            y1="1826.119"
            x2="1491.708"
            y2="1826.306"
          />
          <polygon
            style="clip-path:url(#SVGID_4_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            points="
			1554.793,1819.926 1569.723,1828.546 1554.793,1837.166 		"
          />
        </g>
        <g>
          <defs>
            <rect id="SVGID_5_" y="0.004" width="4077.408" height="2573.926" />
          </defs>
          <clipPath id="SVGID_6_">
            <use xlink:href="#SVGID_5_" style="overflow:visible;" />
          </clipPath>
          <polyline
            style="clip-path:url(#SVGID_6_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            points="
			3297.505,892.32 3297.505,1090.32 3897.505,1090.32 3897.505,1385.652 		"
          />
          <polyline
            style="clip-path:url(#SVGID_6_);fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            points="
			3899.063,1559.319 3899.063,1945.319 3783.504,1945.319 3783.504,1225.32 		"
          />

          <line
            style="clip-path:url(#SVGID_6_);fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            x1="824.004"
            y1="1646.319"
            x2="824.004"
            y2="1226.32"
          />
        </g>
      </g>
      <g id="图层_2">
        <g id="M40005">
          <text
            id="C40005"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 63.0176 1679.2061)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >一期1#进线柜</text>
          <path
            id="B40005"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M112.5,1660.51
			c0,3.172-3.64,1.92-6.856,1.92H50.79c-3.222,0-7.29,1.252-7.29-1.92v-52.626c0-3.169,4.068-5.454,7.29-5.454h54.854
			c3.216,0,6.856,2.285,6.856,5.454V1660.51z"
          />

          <rect
            id="A40005"
            x="47.5"
            y="1604.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="58"
            height="36"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M81.458,1651.604
			c0,1.726-1.397,3.123-3.12,3.123c-1.727,0-3.125-1.397-3.125-3.123c0-1.722,1.397-3.12,3.125-3.12
			C80.06,1648.484,81.458,1649.883,81.458,1651.604z"
          />
          <rect
            x="76.5"
            y="1613.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="7"
          />

          <rect
            x="66.49"
            y="1616.825"
            transform="matrix(0.8661 -0.4999 0.4999 0.8661 -801.0665 250.7079)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />

          <rect
            x="58.523"
            y="1624.792"
            transform="matrix(0.5005 -0.8658 0.8658 0.5005 -1380.2947 865.0746)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />

          <rect
            x="96.008"
            y="1624.735"
            transform="matrix(0.4999 0.8661 -0.8661 0.4999 1459.0245 730.5392)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.682"
          />

          <rect
            x="88.041"
            y="1616.882"
            transform="matrix(0.8659 0.5002 -0.5002 0.8659 822.6795 172.8339)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.685"
          />
          <rect
            x="76.5"
            y="1613.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="7"
          />
          <polygon
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            points="77.668,1636.445 76.102,1637.248
			70.212,1625.695 71.782,1624.894 		"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M82.172,1640.43c-0.09-3-1.771-3.684-3.834-3.684
			c-2.073,0-3.748,0.684-3.834,3.684H82.172z"
          />
        </g>
        <g id="M10111">
          <text
            id="C10111"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 63.0176 1679.2061)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >一期1#进线柜</text>
          <path
            id="B10111"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M112.5,1660.51
			c0,3.172-3.64,1.92-6.856,1.92H50.79c-3.222,0-7.29,1.252-7.29-1.92v-52.626c0-3.169,4.068-5.454,7.29-5.454h54.854
			c3.216,0,6.856,2.285,6.856,5.454V1660.51z"
          />

          <rect
            id="A10111"
            x="47.5"
            y="1604.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="58"
            height="36"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M81.458,1651.604
			c0,1.726-1.397,3.123-3.12,3.123c-1.727,0-3.125-1.397-3.125-3.123c0-1.722,1.397-3.12,3.125-3.12
			C80.06,1648.484,81.458,1649.883,81.458,1651.604z"
          />
          <rect
            x="76.5"
            y="1613.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="7"
          />

          <rect
            x="66.49"
            y="1616.825"
            transform="matrix(0.8661 -0.4999 0.4999 0.8661 -801.0665 250.7079)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />

          <rect
            x="58.523"
            y="1624.792"
            transform="matrix(0.5005 -0.8658 0.8658 0.5005 -1380.2947 865.0746)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />

          <rect
            x="96.008"
            y="1624.735"
            transform="matrix(0.4999 0.8661 -0.8661 0.4999 1459.0245 730.5392)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.682"
          />

          <rect
            x="88.041"
            y="1616.882"
            transform="matrix(0.8659 0.5002 -0.5002 0.8659 822.6795 172.8339)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.685"
          />
          <rect
            x="76.5"
            y="1613.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="7"
          />
          <polygon
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            points="77.668,1636.445 76.102,1637.248
			70.212,1625.695 71.782,1624.894 		"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M82.172,1640.43c-0.09-3-1.771-3.684-3.834-3.684
			c-2.073,0-3.748,0.684-3.834,3.684H82.172z"
          />
        </g>
        <g id="M10121">
          <text
            id="C10121"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 336.9751 1667.2041)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >1#电容（主）</text>
          <path
            id="B10121"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M392.5,1648.51
			c0,3.172-1.471,1.92-4.689,1.92h-54.853c-3.223,0-6.458,1.252-6.458-1.92v-52.626c0-3.169,3.235-5.454,6.458-5.454h54.853
			c3.218,0,4.689,2.285,4.689,5.454V1648.51z"
          />

          <rect
            id="A10121"
            x="329.5"
            y="1592.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="59"
            height="36"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M363.626,1639.604
			c0,1.726-1.397,3.123-3.12,3.123c-1.727,0-3.124-1.397-3.124-3.123c0-1.722,1.397-3.12,3.124-3.12
			C362.229,1636.484,363.626,1637.883,363.626,1639.604z"
          />
          <rect
            x="359.5"
            y="1601.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="2"
            height="7"
          />

          <rect
            x="348.658"
            y="1604.825"
            transform="matrix(0.866 -0.5 0.5 0.866 -757.4432 390.2845)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />

          <rect
            x="340.692"
            y="1612.792"
            transform="matrix(0.5008 -0.8655 0.8655 0.5008 -1228.724 1102.6802)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.683"
          />

          <rect
            x="378.176"
            y="1612.735"
            transform="matrix(0.5006 0.8657 -0.8657 0.5006 1588.7567 479.0842)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="370.209"
            y="1604.882"
            transform="matrix(0.8659 0.5002 -0.5002 0.8659 854.5184 30.074)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.685"
          />
          <rect
            x="359.5"
            y="1601.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="2"
            height="7"
          />
          <polygon
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            points="359.836,1624.445 358.27,1625.248
			352.381,1613.695 353.95,1612.894 		"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M364.34,1628.43c-0.09-3-1.771-3.684-3.834-3.684
			c-2.073,0-3.748,0.684-3.834,3.684H364.34z"
          />
        </g>
        <g id="M10131">
          <text
            id="C10131"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 546.3003 1675.207)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >1#电容（辅）</text>
          <path
            id="B10131"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M602.5,1656.51
			c0,3.172-2.985,1.92-6.203,1.92h-54.854c-3.221,0-4.943,1.252-4.943-1.92v-52.626c0-3.169,1.722-5.454,4.943-5.454h54.854
			c3.218,0,6.203,2.285,6.203,5.454V1656.51z"
          />

          <rect
            id="A10131"
            x="540.5"
            y="1600.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="59"
            height="36"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M572.11,1647.604
			c0,1.726-1.397,3.123-3.12,3.123c-1.725,0-3.123-1.397-3.123-3.123c0-1.722,1.397-3.12,3.123-3.12
			C570.713,1644.484,572.11,1645.883,572.11,1647.604z"
          />
          <rect
            x="565.5"
            y="1609.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="7"
          />

          <rect
            x="557.143"
            y="1612.825"
            transform="matrix(0.866 -0.5 0.5 0.866 -733.5156 495.5911)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />

          <rect
            x="549.176"
            y="1620.792"
            transform="matrix(0.5001 -0.866 0.866 0.5001 -1131.8766 1288.6052)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.685"
          />

          <rect
            x="586.661"
            y="1620.735"
            transform="matrix(0.5 0.866 -0.866 0.5 1700.6675 303.3346)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.682"
          />

          <rect
            x="578.695"
            y="1612.882"
            transform="matrix(0.8657 0.5006 -0.5006 0.8657 887.1248 -73.0273)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />
          <rect
            x="565.5"
            y="1609.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="7"
          />
          <polygon
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            points="568.321,1632.445 566.756,1633.248
			560.866,1621.695 562.437,1620.894 		"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M572.825,1636.43c-0.091-3-1.771-3.684-3.834-3.684
			c-2.071,0-3.748,0.684-3.834,3.684H572.825z"
          />
        </g>
        <g id="M10141">
          <text
            id="C10141"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 761.9922 1679.21)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >馈电柜（大注塑）</text>
          <path
            id="B10141"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M803.5,1660.51
			c0,3.172-3.538,1.92-6.756,1.92h-54.853c-3.223,0-7.392,1.252-7.392-1.92v-52.626c0-3.169,4.168-5.454,7.392-5.454h54.853
			c3.218,0,6.756,2.285,6.756,5.454V1660.51z"
          />

          <rect
            id="A10141"
            x="741.5"
            y="1604.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="58"
            height="36"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M772.558,1651.604
			c0,1.726-1.396,3.123-3.118,3.123c-1.727,0-3.125-1.397-3.125-3.123c0-1.722,1.397-3.12,3.125-3.12
			C771.162,1648.484,772.558,1649.883,772.558,1651.604z"
          />
          <rect
            x="766.5"
            y="1613.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="7"
          />

          <rect
            x="757.592"
            y="1616.825"
            transform="matrix(0.8661 -0.4999 0.4999 0.8661 -708.5344 596.1581)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />

          <rect
            x="749.624"
            y="1624.793"
            transform="matrix(0.5003 -0.8659 0.8659 0.5003 -1035.0955 1463.7964)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.682"
          />

          <rect
            x="787.109"
            y="1624.735"
            transform="matrix(0.5006 0.8657 -0.8657 0.5006 1803.3593 131.0764)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="779.142"
            y="1616.882"
            transform="matrix(0.8658 0.5003 -0.5003 0.8658 915.5913 -172.8618)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />
          <rect
            x="766.5"
            y="1613.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="7"
          />
          <polygon
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            points="768.769,1636.445 767.203,1637.248
			761.314,1625.695 762.884,1624.894 		"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M773.274,1640.43c-0.091-3-1.772-3.684-3.834-3.684
			c-2.072,0-3.749,0.684-3.836,3.684H773.274z"
          />
        </g>
        <g id="M10151">
          <text
            id="C10151"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 1134.3911 1459.2695)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >1#空压机</text>
          <path
            id="B10151"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M1182.5,1440.569
			c0,3.171-2.265,4.86-5.482,4.86h-54.853c-3.223,0-8.665-1.689-8.665-4.86v-52.627c0-3.169,5.442-7.513,8.665-7.513h54.853
			c3.218,0,5.482,4.344,5.482,7.513V1440.569z"
          />

          <rect
            id="A10151"
            x="1117.5"
            y="1387.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="59"
            height="31"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M1152.831,1431.663
			c0,1.726-1.396,3.122-3.118,3.122c-1.727,0-3.124-1.396-3.124-3.122c0-1.723,1.397-3.12,3.124-3.12
			C1151.435,1428.543,1152.831,1429.94,1152.831,1431.663z"
          />
          <rect
            x="1147.5"
            y="1393.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="9"
          />

          <rect
            x="1137.865"
            y="1396.886"
            transform="matrix(0.866 -0.5 0.5 0.866 -547.7629 757.0056)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.682"
          />

          <rect
            x="1129.898"
            y="1404.852"
            transform="matrix(0.5007 -0.8656 0.8656 0.5007 -654.7485 1682.3057)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.921"
            height="7.682"
          />

          <rect
            x="1167.383"
            y="1404.793"
            transform="matrix(0.5006 0.8657 -0.8657 0.5006 1802.865 -307.9507)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="1159.415"
            y="1396.942"
            transform="matrix(0.8656 0.5007 -0.5007 0.8656 857.3569 -392.7736)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />
          <rect
            x="1147.5"
            y="1393.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="9"
          />

          <rect
            x="1144.436"
            y="1404.647"
            transform="matrix(0.8904 -0.4552 0.4552 0.8904 -516.7988 676.0027)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.759"
            height="12.966"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M1153.547,1418.43c-0.09,0-1.771-3.683-3.834-3.683
			c-2.072,0-3.748,3.683-3.835,3.683H1153.547z"
          />
        </g>
        <g id="M10152">
          <text
            id="C10152"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 1125.9209 1725.2061)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >12真空铣刀风机</text>
          <path
            id="B10152"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M1182.5,1706.51
			c0,3.172-2.123,1.92-5.342,1.92h-54.853c-3.223,0-8.806,1.252-8.806-1.92v-52.626c0-3.169,5.583-5.454,8.806-5.454h54.853
			c3.219,0,5.342,2.285,5.342,5.454V1706.51z"
          />

          <rect
            id="A10152"
            x="1116.5"
            y="1650.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="62"
            height="36"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M1152.972,1697.604
			c0,1.726-1.397,3.123-3.118,3.123c-1.727,0-3.124-1.397-3.124-3.123c0-1.722,1.397-3.12,3.124-3.12
			C1151.574,1694.484,1152.972,1695.883,1152.972,1697.604z"
          />
          <rect
            x="1149.5"
            y="1659.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="7"
          />

          <rect
            x="1138.005"
            y="1662.825"
            transform="matrix(0.8659 -0.5003 0.5003 0.8659 -681.0381 793.3927)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.921"
            height="7.685"
          />

          <rect
            x="1130.038"
            y="1670.792"
            transform="matrix(0.5003 -0.8659 0.8659 0.5003 -884.8192 1816.1743)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.683"
          />

          <rect
            x="1167.523"
            y="1670.735"
            transform="matrix(0.5 0.866 -0.866 0.5 2034.3723 -174.6938)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="1159.556"
            y="1662.882"
            transform="matrix(0.8658 0.5003 -0.5003 0.8658 989.6489 -357.0283)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />
          <rect
            x="1149.5"
            y="1659.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="7"
          />
          <polygon
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            points="1149.184,1682.445 1147.617,1683.248
			1141.729,1671.695 1143.298,1670.894 		"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M1153.688,1686.43c-0.091-3-1.772-3.684-3.835-3.684
			c-2.072,0-3.748,0.684-3.835,3.684H1153.688z"
          />
        </g>
        <g id="M10153">
          <text
            id="C10153"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 1130.957 1988.2031)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >发泡、激光、风机</text>
          <path
            id="B10153"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M1194.5,1969.51
			c0,3.172-3.799,1.92-7.015,1.92h-54.854c-3.222,0-7.131,1.252-7.131-1.92v-52.626c0-3.169,3.909-5.454,7.131-5.454h54.854
			c3.216,0,7.015,2.285,7.015,5.454V1969.51z"
          />

          <rect
            id="A10153"
            x="1128.5"
            y="1913.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="59"
            height="36"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M1163.298,1960.604
			c0,1.726-1.397,3.123-3.12,3.123c-1.726,0-3.123-1.397-3.123-3.123c0-1.722,1.397-3.12,3.123-3.12
			C1161.901,1957.484,1163.298,1958.883,1163.298,1960.604z"
          />
          <rect
            x="1157.5"
            y="1922.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="7"
          />

          <rect
            x="1148.331"
            y="1925.825"
            transform="matrix(0.866 -0.5 0.5 0.866 -810.8125 833.0916)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />

          <rect
            x="1140.364"
            y="1933.792"
            transform="matrix(0.5003 -0.8659 0.8659 0.5003 -1107.3835 1956.5454)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />

          <rect
            x="1177.849"
            y="1933.735"
            transform="matrix(0.5002 0.8659 -0.8659 0.5002 2266.8552 -52.3872)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.683"
          />

          <rect
            x="1169.883"
            y="1925.882"
            transform="matrix(0.8656 0.5007 -0.5007 0.8656 1123.4861 -326.9253)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.921"
            height="7.684"
          />
          <rect
            x="1157.5"
            y="1922.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="7"
          />

          <rect
            x="1154.901"
            y="1933.587"
            transform="matrix(0.8899 -0.4561 0.4561 0.8899 -757.6055 740.6311)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.76"
            height="12.967"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M1164.013,1949.43c-0.09-3-1.771-3.684-3.834-3.684
			c-2.071,0-3.748,0.684-3.834,3.684H1164.013z"
          />
        </g>
        <g id="M10154">
          <text
            id="C10154"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 1132.8555 2255.542)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >一期生活办公楼</text>
          <path
            id="B10154"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M1190.5,2236.846
			c0,3.17-1.583,2.584-4.799,2.584h-54.854c-3.222,0-9.347,0.586-9.347-2.584v-52.628c0-3.169,6.125-6.788,9.347-6.788h54.854
			c3.216,0,4.799,3.619,4.799,6.788V2236.846z"
          />

          <rect
            id="A10154"
            x="1128.5"
            y="2179.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="60"
            height="34"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M1161.515,2227.938
			c0,1.726-1.397,3.123-3.12,3.123c-1.727,0-3.123-1.397-3.123-3.123c0-1.722,1.396-3.119,3.123-3.119
			C1160.117,2224.818,1161.515,2226.216,1161.515,2227.938z"
          />
          <rect
            x="1159.5"
            y="2190.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="2"
            height="7"
          />

          <rect
            x="1146.547"
            y="2193.161"
            transform="matrix(0.8661 -0.4999 0.4999 0.8661 -944.5405 867.7449)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.682"
          />

          <rect
            x="1138.58"
            y="2201.126"
            transform="matrix(0.5002 -0.8659 0.8659 0.5002 -1339.7559 2088.6821)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="1176.066"
            y="2201.068"
            transform="matrix(0.5001 0.866 -0.866 0.5001 2497.8391 83.0066)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.683"
          />
          <polygon
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            points="1167.971,2200.868 1166.305,2199.905
			1170.149,2193.25 1171.809,2194.213 		"
          />
          <rect
            x="1159.5"
            y="2190.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="2"
            height="7"
          />

          <rect
            x="1153.118"
            y="2200.922"
            transform="matrix(0.8904 -0.4552 0.4552 0.8904 -878.303 767.2306)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.759"
            height="12.967"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M1162.229,2215.43c-0.091-2-1.771-3.684-3.834-3.684
			c-2.073,0-3.748,1.684-3.834,3.684H1162.229z"
          />
        </g>
        <g id="M10161">
          <text
            id="C10161"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 1457.48 1460.375)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >南、北、东线</text>
          <path
            id="B10161"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M1513.5,1441.678
			c0,3.172-3.64,2.752-6.856,2.752h-54.854c-3.222,0-7.29,0.42-7.29-2.752v-52.625c0-3.169,4.068-6.623,7.29-6.623h54.854
			c3.216,0,6.856,3.454,6.856,6.623V1441.678z"
          />

          <rect
            id="A10161"
            x="1448.5"
            y="1386.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="58"
            height="33"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M1482.458,1432.772
			c0,1.726-1.397,3.123-3.12,3.123c-1.727,0-3.125-1.397-3.125-3.123c0-1.722,1.397-3.119,3.125-3.119
			C1481.06,1429.653,1482.458,1431.051,1482.458,1432.772z"
          />
          <rect
            x="1477.5"
            y="1395.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="7"
          />

          <rect
            x="1467.49"
            y="1397.993"
            transform="matrix(0.8657 -0.5006 0.5006 0.8657 -504.5231 923.4392)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="1459.523"
            y="1405.96"
            transform="matrix(0.5002 -0.8659 0.8659 0.5002 -490.8345 1969.1875)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="1497.008"
            y="1405.904"
            transform="matrix(0.4999 0.8661 -0.8661 0.4999 1970.1968 -592.3274)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.682"
          />

          <rect
            x="1489.041"
            y="1398.051"
            transform="matrix(0.8659 0.5002 -0.5002 0.8659 901.1013 -557.3433)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.685"
          />
          <rect
            x="1477.5"
            y="1395.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="7"
          />

          <rect
            x="1474.06"
            y="1405.756"
            transform="matrix(0.8902 -0.4556 0.4556 0.8902 -481.4644 827.1326)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.76"
            height="12.966"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M1483.172,1422.43c-0.09-3-1.771-3.683-3.834-3.683
			c-2.073,0-3.748,0.683-3.834,3.683H1483.172z"
          />
        </g>
        <g id="M10162">
          <text
            id="C10162"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 1468.6968 1595.377)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >备用</text>
          <path
            id="B10162"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M1509.5,1576.678
			c0,3.172-1.471,2.752-4.689,2.752h-54.853c-3.223,0-6.458,0.42-6.458-2.752v-52.625c0-3.169,3.235-6.623,6.458-6.623h54.853
			c3.218,0,4.689,3.454,4.689,6.623V1576.678z"
          />

          <rect
            id="A10162"
            x="1446.5"
            y="1521.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="59"
            height="33"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M1480.626,1567.772
			c0,1.726-1.397,3.123-3.12,3.123c-1.727,0-3.124-1.397-3.124-3.123c0-1.722,1.397-3.119,3.124-3.119
			C1479.229,1564.653,1480.626,1566.051,1480.626,1567.772z"
          />
          <rect
            x="1476.5"
            y="1530.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="2"
            height="7"
          />

          <rect
            x="1465.658"
            y="1532.993"
            transform="matrix(0.8656 -0.5007 0.5007 0.8656 -572.4282 940.9161)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="1457.691"
            y="1540.961"
            transform="matrix(0.5006 -0.8657 0.8657 0.5006 -608.8601 2034.161)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.683"
          />

          <rect
            x="1495.177"
            y="1540.904"
            transform="matrix(0.5006 0.8657 -0.8657 0.5006 2084.387 -523.7397)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="1487.209"
            y="1533.051"
            transform="matrix(0.8659 0.5002 -0.5002 0.8659 968.3873 -538.3223)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.685"
          />
          <rect
            x="1476.5"
            y="1530.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="2"
            height="7"
          />

          <rect
            x="1472.229"
            y="1540.756"
            transform="matrix(0.8902 -0.4556 0.4556 0.8902 -543.1754 841.1252)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.76"
            height="12.966"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M1481.34,1557.43c-0.09-3-1.771-3.683-3.834-3.683
			c-2.073,0-3.748,0.683-3.834,3.683H1481.34z"
          />
        </g>
        <g id="M10163">
          <text
            id="C10163"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 1458.6616 1747.373)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >注塑区域照明</text>
          <path
            id="B10163"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M1511.5,1728.678
			c0,3.172-0.461,2.752-3.679,2.752h-54.853c-3.221,0-7.469,0.42-7.469-2.752v-52.625c0-3.169,4.248-6.623,7.469-6.623h54.853
			c3.218,0,3.679,3.454,3.679,6.623V1728.678z"
          />

          <rect
            id="A10163"
            x="1449.5"
            y="1673.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="59"
            height="33"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M1483.636,1719.772
			c0,1.726-1.397,3.123-3.12,3.123c-1.727,0-3.124-1.397-3.124-3.123c0-1.722,1.397-3.119,3.124-3.119
			C1482.239,1716.653,1483.636,1718.051,1483.636,1719.772z"
          />
          <rect
            x="1478.5"
            y="1682.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="7"
          />

          <rect
            x="1468.668"
            y="1684.993"
            transform="matrix(0.8656 -0.5007 0.5007 0.8656 -648.1338 962.8514)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="1460.702"
            y="1692.96"
            transform="matrix(0.4999 -0.8661 0.8661 0.4999 -738.5723 2114.6084)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.685"
          />

          <rect
            x="1498.187"
            y="1692.904"
            transform="matrix(0.5 0.866 -0.866 0.5 2218.8877 -449.9651)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.682"
          />

          <rect
            x="1490.22"
            y="1685.051"
            transform="matrix(0.866 0.5001 -0.5001 0.866 1044.5465 -519.3867)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.685"
          />
          <rect
            x="1478.5"
            y="1682.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="7"
          />

          <rect
            x="1475.239"
            y="1692.756"
            transform="matrix(0.8902 -0.4556 0.4556 0.8902 -612.1003 859.1911)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.76"
            height="12.966"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M1484.351,1709.43c-0.091-3-1.771-3.683-3.834-3.683
			c-2.07,0-3.748,0.683-3.834,3.683H1484.351z"
          />
        </g>
        <g id="M10164">
          <text
            id="C10164"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 1468.1914 1894.377)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >真空泵</text>
          <path
            id="B10164"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M1512.5,1875.678
			c0,3.172-2.978,2.752-6.194,2.752h-54.854c-3.222,0-7.952,0.42-7.952-2.752v-52.625c0-3.169,4.73-6.623,7.952-6.623h54.854
			c3.217,0,6.194,3.454,6.194,6.623V1875.678z"
          />

          <rect
            id="A10164"
            x="1450.5"
            y="1820.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="58"
            height="33"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M1482.12,1866.772
			c0,1.726-1.397,3.123-3.12,3.123c-1.726,0-3.123-1.397-3.123-3.123c0-1.722,1.397-3.119,3.123-3.119
			C1480.722,1863.653,1482.12,1865.051,1482.12,1866.772z"
          />
          <rect
            x="1479.5"
            y="1830.057"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="0"
            height="6.52"
          />

          <rect
            x="1467.151"
            y="1831.993"
            transform="matrix(0.8656 -0.5007 0.5007 0.8656 -721.9446 981.8478)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="1459.185"
            y="1839.96"
            transform="matrix(0.5 -0.866 0.866 0.5 -866.7241 2186.3042)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="1496.67"
            y="1839.904"
            transform="matrix(0.4999 0.8661 -0.8661 0.4999 2345.9192 -374.9714)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.683"
          />

          <rect
            x="1488.704"
            y="1832.051"
            transform="matrix(0.8656 0.5007 -0.5007 0.8656 1119.3455 -499.1589)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.921"
            height="7.684"
          />
          <rect
            x="1479.5"
            y="1830.057"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="0"
            height="6.52"
          />

          <rect
            x="1473.722"
            y="1839.756"
            transform="matrix(0.8902 -0.4556 0.4556 0.8902 -679.2444 874.645)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.76"
            height="12.966"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M1482.834,1856.43c-0.09-3-1.771-3.683-3.834-3.683
			c-2.071,0-3.748,0.683-3.834,3.683H1482.834z"
          />
        </g>
        <g id="M10165">
          <text
            id="C10165"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 1468.8818 2043.3789)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >水泵房</text>
          <path
            id="B10165"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M1511.5,2024.678
			c0,3.172-1.283,2.752-4.502,2.752h-54.852c-3.223,0-9.646,0.42-9.646-2.752v-52.625c0-3.169,6.423-6.623,9.646-6.623h54.852
			c3.219,0,4.502,3.454,4.502,6.623V2024.678z"
          />

          <rect
            id="A10165"
            x="1445.5"
            y="1969.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="62"
            height="33"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M1482.813,2015.772
			c0,1.726-1.397,3.123-3.118,3.123c-1.727,0-3.124-1.397-3.124-3.123c0-1.722,1.397-3.119,3.124-3.119
			C1481.415,2012.653,1482.813,2014.051,1482.813,2015.772z"
          />
          <rect
            x="1478.5"
            y="1978.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="7"
          />

          <rect
            x="1467.845"
            y="1980.993"
            transform="matrix(0.8656 -0.5007 0.5007 0.8656 -796.4595 1002.2199)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.685"
          />

          <rect
            x="1459.878"
            y="1988.961"
            transform="matrix(0.4999 -0.8661 0.8661 0.4999 -995.3523 2261.9382)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.682"
          />

          <rect
            x="1497.364"
            y="1988.904"
            transform="matrix(0.4999 0.8661 -0.8661 0.4999 2475.3164 -301.0508)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />

          <rect
            x="1489.397"
            y="1981.051"
            transform="matrix(0.8659 0.5002 -0.5002 0.8659 1192.7861 -479.3347)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />
          <rect
            x="1478.5"
            y="1978.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="7"
          />

          <rect
            x="1474.417"
            y="1988.756"
            transform="matrix(0.8902 -0.4556 0.4556 0.8902 -747.0569 891.3262)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.76"
            height="12.966"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M1483.528,2005.43c-0.09-3-1.771-3.683-3.834-3.683
			c-2.073,0-3.748,0.683-3.834,3.683H1483.528z"
          />
        </g>
        <g id="M10166">
          <text
            id="C10166"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 1464.0054 2193.376)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >北门卫用电</text>
          <path
            id="B10166"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M1516.5,2174.678
			c0,3.172-3.799,2.752-7.015,2.752h-54.854c-3.222,0-7.131,0.42-7.131-2.752v-52.625c0-3.169,3.909-6.623,7.131-6.623h54.854
			c3.216,0,7.015,3.454,7.015,6.623V2174.678z"
          />

          <rect
            id="A10166"
            x="1450.5"
            y="2119.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="59"
            height="33"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M1485.298,2165.772
			c0,1.726-1.397,3.123-3.12,3.123c-1.726,0-3.123-1.397-3.123-3.123c0-1.722,1.397-3.119,3.123-3.119
			C1483.901,2162.653,1485.298,2164.051,1485.298,2165.772z"
          />
          <rect
            x="1479.5"
            y="2128.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="7"
          />

          <rect
            x="1470.33"
            y="2130.993"
            transform="matrix(0.8656 -0.5007 0.5007 0.8656 -871.2344 1023.6233)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="1462.364"
            y="2138.96"
            transform="matrix(0.5 -0.866 0.866 0.5 -1124.0688 2338.5435)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="1499.849"
            y="2138.904"
            transform="matrix(0.5002 0.8659 -0.8659 0.5002 2605.4331 -228.6675)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.683"
          />

          <rect
            x="1491.883"
            y="2131.051"
            transform="matrix(0.8656 0.5007 -0.5007 0.8656 1269.4746 -460.5752)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.921"
            height="7.684"
          />
          <rect
            x="1479.5"
            y="2128.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="7"
          />

          <rect
            x="1476.901"
            y="2138.756"
            transform="matrix(0.8902 -0.4556 0.4556 0.8902 -815.1287 908.9326)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.76"
            height="12.966"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M1486.013,2155.43c-0.09-3-1.771-3.683-3.834-3.683
			c-2.071,0-3.748,0.683-3.834,3.683H1486.013z"
          />
        </g>
        <g id="M10171">
          <text
            id="C10171"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 1816.2085 1393.3379)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >备用</text>
          <path
            id="B10171"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M1857.5,1374.637
			c0,3.174-3.64,4.793-6.856,4.793h-54.854c-3.222,0-7.29-1.619-7.29-4.793v-52.626c0-3.167,4.068-7.581,7.29-7.581h54.854
			c3.216,0,6.856,4.414,6.856,7.581V1374.637z"
          />

          <rect
            id="A10171"
            x="1792.5"
            y="1320.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="58"
            height="33"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M1826.458,1365.731
			c0,1.728-1.397,3.125-3.12,3.125c-1.727,0-3.125-1.397-3.125-3.125c0-1.72,1.397-3.118,3.125-3.118
			C1825.06,1362.613,1826.458,1364.012,1826.458,1365.731z"
          />
          <rect
            x="1821.5"
            y="1326.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="11"
          />

          <rect
            x="1811.49"
            y="1330.954"
            transform="matrix(0.8661 -0.4999 0.4999 0.8661 -424.533 1084.6781)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.682"
          />

          <rect
            x="1803.523"
            y="1338.921"
            transform="matrix(0.5005 -0.8658 0.8658 0.5005 -261.0928 2233.0244)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />

          <rect
            x="1841.008"
            y="1338.864"
            transform="matrix(0.4999 0.8661 -0.8661 0.4999 2084.1829 -923.7988)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.682"
          />

          <rect
            x="1833.041"
            y="1331.011"
            transform="matrix(0.8659 0.5002 -0.5002 0.8659 913.6989 -738.415)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.683"
          />
          <rect
            x="1821.5"
            y="1326.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="11"
          />
          <polygon
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            points="1822.668,1350.574 1821.102,1351.377
			1815.212,1339.824 1816.782,1339.022 		"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M1827.172,1353.43c-0.09,0-1.771-3.683-3.834-3.683
			c-2.073,0-3.748,3.683-3.834,3.683H1827.172z"
          />
        </g>
        <g id="M10172">
          <text
            id="C10172"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 1816.6953 1539.3379)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >直流屏</text>
          <path
            id="B10172"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M1859.5,1520.637
			c0,3.174-1.471,4.793-4.689,4.793h-54.853c-3.223,0-6.458-1.619-6.458-4.793v-52.626c0-3.167,3.235-7.581,6.458-7.581h54.853
			c3.218,0,4.689,4.414,4.689,7.581V1520.637z"
          />

          <rect
            id="A10172"
            x="1796.5"
            y="1466.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="59"
            height="33"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M1830.626,1511.731
			c0,1.728-1.397,3.125-3.12,3.125c-1.727,0-3.124-1.397-3.124-3.125c0-1.72,1.397-3.118,3.124-3.118
			C1829.229,1508.613,1830.626,1510.012,1830.626,1511.731z"
          />
          <rect
            x="1826.5"
            y="1472.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="2"
            height="11"
          />

          <rect
            x="1815.658"
            y="1476.954"
            transform="matrix(0.866 -0.5 0.5 0.866 -497.0012 1106.6033)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.682"
          />

          <rect
            x="1807.692"
            y="1484.921"
            transform="matrix(0.5008 -0.8655 0.8655 0.5008 -385.7727 2308.6021)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.683"
          />

          <rect
            x="1845.177"
            y="1484.864"
            transform="matrix(0.5006 0.8657 -0.8657 0.5006 2210.6592 -854.7097)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="1837.209"
            y="1477.011"
            transform="matrix(0.8659 0.5002 -0.5002 0.8659 987.2924 -720.9202)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.683"
          />
          <rect
            x="1826.5"
            y="1472.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="2"
            height="11"
          />
          <polygon
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            points="1826.836,1496.574 1825.27,1497.377
			1819.381,1485.824 1820.95,1485.022 		"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M1831.34,1499.43c-0.09,0-1.771-3.683-3.834-3.683
			c-2.073,0-3.748,3.683-3.834,3.683H1831.34z"
          />
        </g>
        <g id="M10173">
          <text
            id="C10173"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 1798.1357 1684.334)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >料架修理粉碎机</text>
          <path
            id="B10173"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M1855.5,1665.637
			c0,3.174-1.303,4.793-4.521,4.793h-54.853c-3.223,0-6.627-1.619-6.627-4.793v-52.626c0-3.167,3.404-7.581,6.627-7.581h54.853
			c3.218,0,4.521,4.414,4.521,7.581V1665.637z"
          />

          <rect
            id="A10173"
            x="1793.5"
            y="1611.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="59"
            height="33"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M1826.793,1656.731
			c0,1.728-1.397,3.125-3.118,3.125c-1.727,0-3.124-1.397-3.124-3.125c0-1.72,1.397-3.118,3.124-3.118
			C1825.396,1653.613,1826.793,1655.012,1826.793,1656.731z"
          />
          <rect
            x="1822.5"
            y="1617.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="11"
          />

          <rect
            x="1811.827"
            y="1621.954"
            transform="matrix(0.866 -0.5 0.5 0.866 -570.0093 1124.1111)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.682"
          />

          <rect
            x="1803.859"
            y="1629.922"
            transform="matrix(0.5005 -0.8658 0.8658 0.5005 -512.8618 2378.6829)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.682"
          />

          <rect
            x="1841.345"
            y="1629.864"
            transform="matrix(0.5006 0.8657 -0.8657 0.5006 2334.2678 -778.9822)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="1833.377"
            y="1622.011"
            transform="matrix(0.8659 0.5002 -0.5002 0.8659 1059.3125 -699.5571)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.682"
          />
          <rect
            x="1822.5"
            y="1617.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="11"
          />
          <polygon
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            points="1823.005,1641.574 1821.438,1642.377
			1815.55,1630.824 1817.119,1630.022 		"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M1827.509,1644.43c-0.09,0-1.771-3.683-3.834-3.683
			c-2.072,0-3.748,3.683-3.835,3.683H1827.509z"
          />
        </g>
        <g id="M10174">
          <text
            id="C10174"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 1807.6675 1839.334)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >东门卫用电</text>
          <path
            id="B10174"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M1858.5,1820.637
			c0,3.174-2.134,4.793-5.352,4.793h-54.854c-3.222,0-8.794-1.619-8.794-4.793v-52.626c0-3.167,5.572-7.581,8.794-7.581h54.854
			c3.218,0,5.352,4.414,5.352,7.581V1820.637z"
          />

          <rect
            id="A10174"
            x="1796.5"
            y="1766.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="58"
            height="33"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M1828.961,1811.731
			c0,1.728-1.397,3.125-3.12,3.125c-1.725,0-3.123-1.397-3.123-3.125c0-1.72,1.397-3.118,3.123-3.118
			C1827.564,1808.613,1828.961,1810.012,1828.961,1811.731z"
          />
          <rect
            x="1825.5"
            y="1772.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="11"
          />

          <rect
            x="1813.995"
            y="1776.953"
            transform="matrix(0.8659 -0.5003 0.5003 0.8659 -647.4553 1146.8964)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.921"
            height="7.683"
          />

          <rect
            x="1806.028"
            y="1784.922"
            transform="matrix(0.5005 -0.8658 0.8658 0.5005 -645.9717 2457.9897)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.682"
          />

          <rect
            x="1843.513"
            y="1784.864"
            transform="matrix(0.4999 0.8661 -0.8661 0.4999 2471.7202 -702.9033)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />

          <rect
            x="1835.546"
            y="1777.011"
            transform="matrix(0.8658 0.5003 -0.5003 0.8658 1137.4526 -679.9436)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.682"
          />
          <rect
            x="1825.5"
            y="1772.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="11"
          />
          <polygon
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            points="1825.172,1796.574 1823.607,1797.377
			1817.716,1785.824 1819.288,1785.022 		"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M1829.676,1799.43c-0.089,0-1.77-3.683-3.834-3.683
			c-2.071,0-3.748,3.683-3.834,3.683H1829.676z"
          />
        </g>
        <g id="M10175">
          <text
            id="C10175"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 1818.8833 1977.3389)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >备用</text>
          <path
            id="B10175"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M1859.5,1958.637
			c0,3.174-2.965,4.793-6.184,4.793h-54.854c-3.222,0-7.962-1.619-7.962-4.793v-52.626c0-3.167,4.741-7.581,7.962-7.581h54.854
			c3.218,0,6.184,4.414,6.184,7.581V1958.637z"
          />

          <rect
            id="A10175"
            x="1793.5"
            y="1904.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="62"
            height="33"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M1829.13,1949.731
			c0,1.728-1.397,3.125-3.12,3.125c-1.725,0-3.123-1.397-3.123-3.125c0-1.72,1.397-3.118,3.123-3.118
			C1827.732,1946.613,1829.13,1948.012,1829.13,1949.731z"
          />
          <rect
            x="1826.5"
            y="1911.289"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="0"
            height="9.779"
          />

          <rect
            x="1814.162"
            y="1914.954"
            transform="matrix(0.866 -0.5 0.5 0.866 -716.186 1164.5273)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.682"
          />

          <rect
            x="1806.196"
            y="1922.921"
            transform="matrix(0.5005 -0.8658 0.8658 0.5005 -765.363 2527.072)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />

          <rect
            x="1843.681"
            y="1922.864"
            transform="matrix(0.5 0.866 -0.866 0.5 2590.7642 -634.1929)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.682"
          />

          <rect
            x="1835.714"
            y="1915.011"
            transform="matrix(0.8658 0.5003 -0.5003 0.8658 1206.5227 -661.5117)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.682"
          />
          <rect
            x="1826.5"
            y="1911.289"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="0"
            height="9.779"
          />
          <polygon
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            points="1825.34,1934.574 1823.775,1935.377
			1817.885,1923.824 1819.456,1923.022 		"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M1829.844,1937.43c-0.089,0-1.771-3.683-3.834-3.683
			c-2.071,0-3.748,3.683-3.834,3.683H1829.844z"
          />
        </g>
        <g id="M10176">
          <text
            id="C10176"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 1804.0044 2132.3359)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >一期变电所用电</text>
          <path
            id="B10176"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M1856.5,2113.637
			c0,3.174-3.799,4.793-7.015,4.793h-54.854c-3.222,0-7.131-1.619-7.131-4.793v-52.626c0-3.167,3.909-7.581,7.131-7.581h54.854
			c3.216,0,7.015,4.414,7.015,7.581V2113.637z"
          />

          <rect
            id="A10176"
            x="1790.5"
            y="2059.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="59"
            height="33"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M1825.298,2104.731
			c0,1.728-1.397,3.125-3.12,3.125c-1.726,0-3.123-1.397-3.123-3.125c0-1.72,1.397-3.118,3.123-3.118
			C1823.901,2101.613,1825.298,2103.012,1825.298,2104.731z"
          />
          <rect
            x="1819.5"
            y="2065.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="11"
          />

          <rect
            x="1810.331"
            y="2069.954"
            transform="matrix(0.866 -0.5 0.5 0.866 -794.1936 1183.3744)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.682"
          />

          <rect
            x="1802.364"
            y="2077.921"
            transform="matrix(0.5003 -0.8659 0.8659 0.5003 -901.3562 2601.7793)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />

          <rect
            x="1839.849"
            y="2077.864"
            transform="matrix(0.5002 0.8659 -0.8659 0.5002 2722.499 -553.5757)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.683"
          />

          <rect
            x="1831.883"
            y="2070.011"
            transform="matrix(0.8656 0.5007 -0.5007 0.8656 1284.5969 -639.0068)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.921"
            height="7.682"
          />
          <rect
            x="1819.5"
            y="2065.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="11"
          />

          <rect
            x="1816.901"
            y="2077.716"
            transform="matrix(0.8899 -0.4561 0.4561 0.8899 -750.4814 1058.4108)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.76"
            height="12.967"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M1826.013,2092.43c-0.09,0-1.771-3.683-3.834-3.683
			c-2.071,0-3.748,3.683-3.834,3.683H1826.013z"
          />
        </g>
        <g id="M10177">
          <text
            id="C10177"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 1799.4795 2279.1279)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >总装区域照明</text>
          <path
            id="B10177"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M1855.5,2260.43
			c0,3.174-3.64,2-6.856,2h-54.854c-3.222,0-7.29,1.174-7.29-2v-52.625c0-3.168,4.068-7.375,7.29-7.375h54.854
			c3.216,0,6.856,4.207,6.856,7.375V2260.43z"
          />

          <rect
            id="A10177"
            x="1790.5"
            y="2204.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="58"
            height="36"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M1824.458,2251.526
			c0,1.726-1.397,3.122-3.12,3.122c-1.727,0-3.125-1.396-3.125-3.122c0-1.723,1.397-3.12,3.125-3.12
			C1823.06,2248.406,1824.458,2249.804,1824.458,2251.526z"
          />
          <rect
            x="1819.5"
            y="2213.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="7"
          />

          <rect
            x="1809.49"
            y="2216.747"
            transform="matrix(0.8661 -0.4999 0.4999 0.8661 -867.5684 1202.2778)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.683"
          />

          <rect
            x="1801.523"
            y="2224.714"
            transform="matrix(0.5002 -0.8659 0.8659 0.5002 -1028.865 2674.5059)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="1839.009"
            y="2224.657"
            transform="matrix(0.5001 0.866 -0.866 0.5001 2849.6885 -479.2979)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.683"
          />

          <rect
            x="1831.041"
            y="2216.804"
            transform="matrix(0.8657 0.5006 -0.5006 0.8657 1357.7845 -618.8291)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />
          <rect
            x="1819.5"
            y="2213.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="7"
          />

          <rect
            x="1816.06"
            y="2224.509"
            transform="matrix(0.8902 -0.4556 0.4556 0.8902 -816.9504 1072.8817)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.76"
            height="12.967"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M1825.172,2240.43c-0.09-4-1.771-3.684-3.834-3.684
			c-2.073,0-3.748-0.316-3.834,3.684H1825.172z"
          />
        </g>
        <g id="M10211">
          <text
            id="C10211"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 3934.6533 1660.207)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >一期2#进线柜</text>
          <path
            id="B10211"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M3981.5,1641.51
			c0,3.172-1.004,1.92-4.222,1.92h-54.854c-3.221,0-5.924,1.252-5.924-1.92v-52.626c0-3.169,2.703-5.454,5.924-5.454h54.854
			c3.218,0,4.222,2.285,4.222,5.454V1641.51z"
          />

          <rect
            id="A10211"
            x="3919.5"
            y="1585.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="58"
            height="36"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M3953.092,1632.604
			c0,1.726-1.397,3.123-3.119,3.123c-1.726,0-3.123-1.397-3.123-3.123c0-1.722,1.397-3.12,3.123-3.12
			C3951.694,1629.484,3953.092,1630.883,3953.092,1632.604z"
          />
          <rect
            x="3948.5"
            y="1594.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="7"
          />

          <rect
            x="3938.124"
            y="1597.825"
            transform="matrix(0.8661 -0.4999 0.4999 0.8661 -273.1938 2183.4172)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />

          <rect
            x="3930.158"
            y="1605.792"
            transform="matrix(0.5005 -0.8658 0.8658 0.5005 570.209 4207.498)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />

          <rect
            x="3967.642"
            y="1605.736"
            transform="matrix(0.4999 0.8661 -0.8661 0.4999 3378.9492 -2632.2222)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.682"
          />

          <rect
            x="3959.677"
            y="1597.882"
            transform="matrix(0.8658 0.5005 -0.5005 0.8658 1333.2581 -1767.1104)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />
          <rect
            x="3948.5"
            y="1594.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="7"
          />

          <rect
            x="3944.695"
            y="1605.587"
            transform="matrix(0.8899 -0.4561 0.4561 0.8899 -300.9829 1976.8708)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.76"
            height="12.967"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M3953.807,1621.43c-0.091-3-1.771-3.684-3.834-3.684
			c-2.071,0-3.748,0.684-3.834,3.684H3953.807z"
          />
        </g>
        <g id="M10221">
          <text
            id="C10221"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 3637.457 1667.207)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >2#电容（主）</text>
          <path
            id="B10221"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M3692.5,1648.51
			c0,3.172-1.837,1.92-5.053,1.92h-54.854c-3.222,0-9.093,1.252-9.093-1.92v-52.626c0-3.169,5.871-5.454,9.093-5.454h54.854
			c3.216,0,5.053,2.285,5.053,5.454V1648.51z"
          />

          <rect
            id="A10221"
            x="3629.5"
            y="1592.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="59"
            height="36"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M3663.26,1639.604
			c0,1.726-1.396,3.123-3.119,3.123c-1.727,0-3.123-1.397-3.123-3.123c0-1.722,1.396-3.12,3.123-3.12
			C3661.863,1636.484,3663.26,1637.883,3663.26,1639.604z"
          />
          <rect
            x="3658.5"
            y="1601.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="7"
          />

          <rect
            x="3648.293"
            y="1604.825"
            transform="matrix(0.8661 -0.4999 0.4999 0.8661 -315.4985 2039.481)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />

          <rect
            x="3640.326"
            y="1612.792"
            transform="matrix(0.5005 -0.8658 0.8658 0.5005 419.3645 3960.0693)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />

          <rect
            x="3677.811"
            y="1612.735"
            transform="matrix(0.4999 0.8661 -0.8661 0.4999 3240.0537 -2377.6953)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.683"
          />

          <rect
            x="3669.844"
            y="1604.882"
            transform="matrix(0.8656 0.5007 -0.5007 0.8656 1298.6763 -1621.7263)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.921"
            height="7.684"
          />
          <rect
            x="3658.5"
            y="1601.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="7"
          />
          <polygon
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            points="3659.471,1624.445 3657.904,1625.248
			3652.016,1613.695 3653.584,1612.894 		"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M3663.975,1628.43c-0.09-3-1.771-3.684-3.834-3.684
			c-2.07,0-3.748,0.684-3.834,3.684H3663.975z"
          />
        </g>
        <g id="M10231">
          <text
            id="C10231"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 3432.625 1672.2051)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >2#电容（辅）</text>
          <path
            id="B10231"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M3487.5,1653.51
			c0,3.172-1.668,1.92-4.887,1.92h-54.852c-3.224,0-9.262,1.252-9.262-1.92v-52.626c0-3.169,6.038-5.454,9.262-5.454h54.852
			c3.219,0,4.887,2.285,4.887,5.454V1653.51z"
          />

          <rect
            id="A10231"
            x="3425.5"
            y="1597.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="58"
            height="36"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M3458.429,1644.604
			c0,1.726-1.397,3.123-3.12,3.123c-1.727,0-3.123-1.397-3.123-3.123c0-1.722,1.396-3.12,3.123-3.12
			C3457.031,1641.484,3458.429,1642.883,3458.429,1644.604z"
          />
          <rect
            x="3454.5"
            y="1606.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="7"
          />

          <rect
            x="3443.462"
            y="1609.825"
            transform="matrix(0.866 -0.5001 0.5001 0.866 -345.3406 1938.7271)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />

          <rect
            x="3435.494"
            y="1617.792"
            transform="matrix(0.5008 -0.8655 0.8655 0.5008 311.7622 3783.8584)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.683"
          />

          <rect
            x="3472.98"
            y="1617.735"
            transform="matrix(0.5006 0.8657 -0.8657 0.5006 3138.5806 -2197.4958)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="3465.012"
            y="1609.882"
            transform="matrix(0.8659 0.5002 -0.5002 0.8659 1272.0649 -1517.385)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />
          <rect
            x="3454.5"
            y="1606.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="7"
          />
          <polygon
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            points="3454.639,1629.445 3453.072,1630.248
			3447.184,1618.695 3448.753,1617.894 		"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M3459.143,1633.43c-0.09-3-1.771-3.684-3.834-3.684
			c-2.071,0-3.748,0.684-3.834,3.684H3459.143z"
          />
        </g>
        <g id="M10241">
          <text
            id="C10241"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 3238.9385 1594.2041)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >一期办公楼用电</text>
          <path
            id="B10241"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M3297.5,1575.51
			c0,3.172-2.5,1.92-5.718,1.92h-54.853c-3.223,0-8.43,1.252-8.43-1.92v-52.626c0-3.169,5.207-5.454,8.43-5.454h54.853
			c3.218,0,5.718,2.285,5.718,5.454V1575.51z"
          />

          <rect
            id="A10241"
            x="3232.5"
            y="1519.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="61"
            height="36"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M3267.596,1566.604
			c0,1.726-1.396,3.123-3.118,3.123c-1.727,0-3.124-1.397-3.124-3.123c0-1.722,1.397-3.12,3.124-3.12
			C3266.199,1563.484,3267.596,1564.883,3267.596,1566.604z"
          />
          <rect
            x="3264.5"
            y="1529.306"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="0"
            height="6.52"
          />

          <rect
            x="3252.63"
            y="1531.825"
            transform="matrix(0.866 -0.5001 0.5001 0.866 -331.9097 1832.8438)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />

          <rect
            x="3244.663"
            y="1539.793"
            transform="matrix(0.5008 -0.8655 0.8655 0.5008 284.0181 3579.7507)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.682"
          />

          <rect
            x="3282.148"
            y="1539.735"
            transform="matrix(0.5006 0.8657 -0.8657 0.5006 2975.7598 -2071.2502)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="3274.181"
            y="1531.882"
            transform="matrix(0.8658 0.5005 -0.5005 0.8658 1208.2087 -1432.9102)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />
          <rect
            x="3264.5"
            y="1529.306"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="0"
            height="6.52"
          />
          <polygon
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            points="3263.808,1551.445 3262.241,1552.248
			3256.353,1540.695 3257.922,1539.894 		"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M3268.312,1555.43c-0.091-3-1.771-3.684-3.834-3.684
			c-2.072,0-3.748,0.684-3.834,3.684H3268.312z"
          />
        </g>
        <g id="M10242">
          <text
            id="C10242"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 3034.9629 1737.2051)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >1#阴模成型机</text>
          <path
            id="B10242"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M3091.5,1718.51
			c0,3.172-3.332,1.92-6.549,1.92h-54.854c-3.222,0-7.597,1.252-7.597-1.92v-52.626c0-3.169,4.375-5.454,7.597-5.454h54.854
			c3.217,0,6.549,2.285,6.549,5.454V1718.51z"
          />

          <rect
            id="A10242"
            x="3026.5"
            y="1662.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="58"
            height="36"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M3060.764,1709.604
			c0,1.726-1.396,3.123-3.119,3.123c-1.725,0-3.123-1.397-3.123-3.123c0-1.722,1.398-3.12,3.123-3.12
			C3059.367,1706.484,3060.764,1707.883,3060.764,1709.604z"
          />
          <rect
            x="3055.5"
            y="1671.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="7"
          />

          <rect
            x="3045.797"
            y="1674.825"
            transform="matrix(0.866 -0.5001 0.5001 0.866 -431.1396 1748.5764)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.685"
          />

          <rect
            x="3037.831"
            y="1682.793"
            transform="matrix(0.5008 -0.8655 0.8655 0.5008 57.0027 3472.1094)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.682"
          />

          <rect
            x="3075.315"
            y="1682.735"
            transform="matrix(0.5002 0.8659 -0.8659 0.5002 2997.8037 -1820.8245)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="3067.349"
            y="1674.882"
            transform="matrix(0.8658 0.5005 -0.5005 0.8658 1252.009 -1310.2039)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />
          <rect
            x="3055.5"
            y="1671.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="7"
          />
          <polygon
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            points="3056.977,1694.445 3055.41,1695.248
			3049.521,1683.695 3051.09,1682.894 		"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M3061.48,1698.43c-0.091-3-1.771-3.684-3.836-3.684
			c-2.07,0-3.747,0.684-3.834,3.684H3061.48z"
          />
        </g>
        <g id="M10243">
          <text
            id="C10243"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 3035.4941 2008.207)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >2#空压机</text>
          <path
            id="B10243"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M3081.5,1989.51
			c0,3.172-0.162,1.92-3.381,1.92h-54.854c-3.222,0-6.766,1.252-6.766-1.92v-52.626c0-3.169,3.544-5.454,6.766-5.454h54.854
			c3.219,0,3.381,2.285,3.381,5.454V1989.51z"
          />

          <rect
            id="A10243"
            x="3020.5"
            y="1933.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="58"
            height="36"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M3053.933,1980.604
			c0,1.726-1.397,3.123-3.12,3.123c-1.725,0-3.122-1.397-3.122-3.123c0-1.722,1.397-3.12,3.122-3.12
			C3052.535,1977.484,3053.933,1978.883,3053.933,1980.604z"
          />
          <rect
            x="3049.5"
            y="1942.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="2"
            height="7"
          />

          <rect
            x="3038.966"
            y="1945.825"
            transform="matrix(0.866 -0.5001 0.5001 0.866 -567.5752 1781.4788)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />

          <rect
            x="3030.999"
            y="1953.792"
            transform="matrix(0.5005 -0.8658 0.8658 0.5005 -180.2466 3602.8818)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />

          <rect
            x="3068.484"
            y="1953.735"
            transform="matrix(0.5002 0.8659 -0.8659 0.5002 3229.0454 -1679.4729)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.683"
          />

          <rect
            x="3060.517"
            y="1945.882"
            transform="matrix(0.8659 0.5002 -0.5002 0.8659 1385.897 -1269.981)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />
          <rect
            x="3049.5"
            y="1942.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="2"
            height="7"
          />
          <polygon
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            points="3050.143,1965.445 3048.578,1966.248
			3042.688,1954.695 3044.259,1953.894 		"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M3054.646,1969.43c-0.089-3-1.771-3.684-3.834-3.684
			c-2.07,0-3.748,0.684-3.834,3.684H3054.646z"
          />
        </g>
        <g id="M10251">
          <text
            id="C10251"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 3043.1631 1486.377)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >馈电柜（接1#、2#冷冻机组）</text>
          <path
            id="B10251"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M3085.5,1467.678
			c0,3.172-1.004,2.752-4.222,2.752h-54.854c-3.221,0-5.924,0.42-5.924-2.752v-52.625c0-3.169,2.703-6.623,5.924-6.623h54.854
			c3.218,0,4.222,3.454,4.222,6.623V1467.678z"
          />

          <rect
            id="A10251"
            x="3023.5"
            y="1412.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="58"
            height="33"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M3057.092,1458.772
			c0,1.726-1.397,3.123-3.119,3.123c-1.726,0-3.123-1.397-3.123-3.123c0-1.722,1.397-3.119,3.123-3.119
			C3055.694,1455.653,3057.092,1457.051,3057.092,1458.772z"
          />
          <rect
            x="3052.5"
            y="1421.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="7"
          />

          <rect
            x="3042.124"
            y="1423.993"
            transform="matrix(0.8657 -0.5006 0.5006 0.8657 -306.0176 1715.2188)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="3034.157"
            y="1431.96"
            transform="matrix(0.5002 -0.8659 0.8659 0.5002 273.5991 3345.6406)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="3071.642"
            y="1431.905"
            transform="matrix(0.4999 0.8661 -0.8661 0.4999 2780.2617 -1943.1292)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.682"
          />

          <rect
            x="3063.677"
            y="1424.051"
            transform="matrix(0.8658 0.5005 -0.5005 0.8658 1125.9863 -1342.0371)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />
          <rect
            x="3052.5"
            y="1421.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="7"
          />

          <rect
            x="3048.695"
            y="1431.756"
            transform="matrix(0.8902 -0.4556 0.4556 0.8902 -320.3682 1547.4376)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.76"
            height="12.967"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M3057.807,1448.43c-0.091-3-1.771-3.683-3.834-3.683
			c-2.071,0-3.748,0.683-3.834,3.683H3057.807z"
          />
        </g>
        <g id="M10271">
          <text
            id="C10271"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 2729.9668 2055.375)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >真空成型机</text>
          <path
            id="B10271"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M2780.5,2036.678
			c0,3.172-1.837,2.752-5.053,2.752h-54.854c-3.222,0-9.093,0.42-9.093-2.752v-52.625c0-3.169,5.871-6.623,9.093-6.623h54.854
			c3.216,0,5.053,3.454,5.053,6.623V2036.678z"
          />

          <rect
            id="A10271"
            x="2717.5"
            y="1981.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="59"
            height="33"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M2751.26,2027.772
			c0,1.726-1.396,3.123-3.119,3.123c-1.727,0-3.123-1.397-3.123-3.123c0-1.722,1.396-3.119,3.123-3.119
			C2749.863,2024.653,2751.26,2026.051,2751.26,2027.772z"
          />
          <rect
            x="2746.5"
            y="1990.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="7"
          />

          <rect
            x="2736.292"
            y="1992.993"
            transform="matrix(0.8657 -0.5006 0.5006 0.8657 -631.9507 1638.5487)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="2728.325"
            y="2000.96"
            transform="matrix(0.5002 -0.8659 0.8659 0.5002 -371.936 3365.1899)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="2765.811"
            y="2000.904"
            transform="matrix(0.4999 0.8661 -0.8661 0.4999 3120.1179 -1393.6626)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.683"
          />

          <rect
            x="2757.844"
            y="1993.051"
            transform="matrix(0.8656 0.5007 -0.5007 0.8656 1370.4823 -1112.9539)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.921"
            height="7.684"
          />
          <rect
            x="2746.5"
            y="1990.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="7"
          />
          <polygon
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            points="2747.471,2012.614 2745.904,2013.416
			2740.016,2001.864 2741.584,2001.063 		"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M2751.975,2017.43c-0.09-3-1.771-3.683-3.834-3.683
			c-2.07,0-3.748,0.683-3.834,3.683H2751.975z"
          />
        </g>
        <g id="M10272">
          <text
            id="C10272"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 2715.4512 2196.3711)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >60发泡、长轴发泡</text>
          <path
            id="B10272"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M2777.5,2177.678
			c0,3.172-1.668,2.752-4.887,2.752h-54.852c-3.224,0-9.262,0.42-9.262-2.752v-52.625c0-3.169,6.038-6.623,9.262-6.623h54.852
			c3.219,0,4.887,3.454,4.887,6.623V2177.678z"
          />

          <rect
            id="A10272"
            x="2715.5"
            y="2122.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="58"
            height="33"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M2748.429,2168.772
			c0,1.726-1.397,3.123-3.12,3.123c-1.727,0-3.123-1.397-3.123-3.123c0-1.722,1.396-3.119,3.123-3.119
			C2747.031,2165.653,2748.429,2167.051,2748.429,2168.772z"
          />
          <rect
            x="2744.5"
            y="2131.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="7"
          />

          <rect
            x="2733.461"
            y="2133.993"
            transform="matrix(0.8655 -0.5008 0.5008 0.8655 -703.04 1656.9458)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="2725.494"
            y="2141.961"
            transform="matrix(0.5006 -0.8657 0.8657 0.5006 -496.0071 3431.7891)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.683"
          />

          <rect
            x="2762.98"
            y="2141.904"
            transform="matrix(0.5006 0.8657 -0.8657 0.5006 3237.7749 -1321.1086)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="2755.012"
            y="2134.051"
            transform="matrix(0.8659 0.5002 -0.5002 0.8659 1439.0544 -1091.9214)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />
          <rect
            x="2744.5"
            y="2131.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="7"
          />

          <rect
            x="2740.031"
            y="2141.756"
            transform="matrix(0.8902 -0.4556 0.4556 0.8902 -677.7654 1484.781)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.76"
            height="12.966"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M2749.143,2158.43c-0.09-3-1.771-3.683-3.834-3.683
			c-2.071,0-3.748,0.683-3.834,3.683H2749.143z"
          />
        </g>
        <g id="M10273">
          <text
            id="C10273"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 2734.3506 1748.377)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >备用</text>
          <path
            id="B10273"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M2774.5,1729.678
			c0,3.172-2.5,2.752-5.718,2.752h-54.853c-3.223,0-8.43,0.42-8.43-2.752v-52.625c0-3.169,5.207-6.623,8.43-6.623h54.853
			c3.218,0,5.718,3.454,5.718,6.623V1729.678z"
          />

          <rect
            id="A10273"
            x="2709.5"
            y="1674.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="61"
            height="33"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M2744.596,1720.772
			c0,1.726-1.396,3.123-3.118,3.123c-1.727,0-3.124-1.397-3.124-3.123c0-1.722,1.397-3.119,3.124-3.119
			C2743.199,1717.653,2744.596,1719.051,2744.596,1720.772z"
          />
          <rect
            x="2741.5"
            y="1684.057"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="0"
            height="6.52"
          />

          <rect
            x="2729.63"
            y="1685.993"
            transform="matrix(0.8655 -0.5008 0.5008 0.8655 -479.1807 1594.7898)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="2721.662"
            y="1693.961"
            transform="matrix(0.5006 -0.8657 0.8657 0.5006 -110.1006 3204.7483)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.682"
          />

          <rect
            x="2759.148"
            y="1693.904"
            transform="matrix(0.5006 0.8657 -0.8657 0.5006 2848.0415 -1541.5154)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="2751.181"
            y="1686.051"
            transform="matrix(0.8658 0.5005 -0.5005 0.8658 1215.1572 -1150.4768)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />
          <rect
            x="2741.5"
            y="1684.057"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="0"
            height="6.52"
          />

          <rect
            x="2736.2"
            y="1693.756"
            transform="matrix(0.8902 -0.4556 0.4556 0.8902 -474.0642 1433.8314)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.76"
            height="12.966"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M2745.312,1710.43c-0.091-3-1.771-3.683-3.834-3.683
			c-2.072,0-3.748,0.683-3.834,3.683H2745.312z"
          />
        </g>
        <g id="M10274">
          <text
            id="C10274"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 2730.6533 1903.3359)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >3#空压机</text>
          <path
            id="B10274"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M2777.5,1884.637
			c0,3.174-1.004,4.793-4.222,4.793h-54.854c-3.221,0-5.924-1.619-5.924-4.793v-52.626c0-3.167,2.703-7.581,5.924-7.581h54.854
			c3.218,0,4.222,4.414,4.222,7.581V1884.637z"
          />

          <rect
            id="A10274"
            x="2715.5"
            y="1830.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="58"
            height="33"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M2749.092,1875.731
			c0,1.728-1.397,3.125-3.119,3.125c-1.726,0-3.123-1.397-3.123-3.125c0-1.72,1.397-3.118,3.123-3.118
			C2747.694,1872.613,2749.092,1874.012,2749.092,1875.731z"
          />
          <rect
            x="2744.5"
            y="1836.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="11"
          />

          <rect
            x="2734.124"
            y="1840.954"
            transform="matrix(0.8661 -0.4999 0.4999 0.8661 -555.9268 1614.145)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.682"
          />

          <rect
            x="2726.158"
            y="1848.921"
            transform="matrix(0.5005 -0.8658 0.8658 0.5005 -241.7346 3286.574)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />

          <rect
            x="2763.642"
            y="1848.865"
            transform="matrix(0.4999 0.8661 -0.8661 0.4999 2987.3501 -1467.8267)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.682"
          />

          <rect
            x="2755.677"
            y="1841.011"
            transform="matrix(0.8658 0.5005 -0.5005 0.8658 1293.3108 -1131.9253)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.682"
          />
          <rect
            x="2744.5"
            y="1836.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="11"
          />

          <rect
            x="2740.695"
            y="1848.716"
            transform="matrix(0.8899 -0.4561 0.4561 0.8899 -544.373 1454.5216)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.76"
            height="12.967"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M2749.807,1863.43c-0.091,0-1.771-3.683-3.834-3.683
			c-2.071,0-3.748,3.683-3.834,3.683H2749.807z"
          />
        </g>
        <g id="M10281">
          <text
            id="C10281"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 2419.0137 1400.3398)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >备用</text>
          <path
            id="B10281"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M2458.5,1381.637
			c0,3.174-1.837,4.793-5.053,4.793h-54.854c-3.222,0-9.093-1.619-9.093-4.793v-52.626c0-3.167,5.871-7.581,9.093-7.581h54.854
			c3.216,0,5.053,4.414,5.053,7.581V1381.637z"
          />

          <rect
            id="A10281"
            x="2395.5"
            y="1327.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="59"
            height="33"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M2429.26,1372.731
			c0,1.728-1.396,3.125-3.119,3.125c-1.727,0-3.123-1.397-3.123-3.125c0-1.72,1.396-3.118,3.123-3.118
			C2427.863,1369.613,2429.26,1371.012,2429.26,1372.731z"
          />
          <rect
            x="2424.5"
            y="1333.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="11"
          />

          <rect
            x="2414.293"
            y="1337.954"
            transform="matrix(0.8661 -0.4999 0.4999 0.8661 -347.3225 1386.929)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.682"
          />

          <rect
            x="2406.326"
            y="1345.921"
            transform="matrix(0.5005 -0.8658 0.8658 0.5005 33.9736 2758.4048)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />

          <rect
            x="2443.811"
            y="1345.864"
            transform="matrix(0.4999 0.8661 -0.8661 0.4999 2391.7346 -1442.3906)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.683"
          />

          <rect
            x="2435.844"
            y="1338.011"
            transform="matrix(0.8656 0.5007 -0.5007 0.8656 999.2537 -1039.751)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.921"
            height="7.682"
          />
          <rect
            x="2424.5"
            y="1333.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="11"
          />
          <polygon
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            points="2425.471,1357.574 2423.904,1358.377
			2418.016,1346.824 2419.584,1346.022 		"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M2429.975,1360.43c-0.09,0-1.771-3.683-3.834-3.683
			c-2.07,0-3.748,3.683-3.834,3.683H2429.975z"
          />
        </g>
        <g id="M10282">
          <text
            id="C10282"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 2423.1816 1537.3379)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >备用</text>
          <path
            id="B10282"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M2462.5,1518.637
			c0,3.174-1.668,4.793-4.887,4.793h-54.852c-3.224,0-9.262-1.619-9.262-4.793v-52.626c0-3.167,6.038-7.581,9.262-7.581h54.852
			c3.219,0,4.887,4.414,4.887,7.581V1518.637z"
          />

          <rect
            id="A10282"
            x="2400.5"
            y="1464.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="58"
            height="33"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M2433.429,1509.731
			c0,1.728-1.397,3.125-3.12,3.125c-1.727,0-3.123-1.397-3.123-3.125c0-1.72,1.396-3.118,3.123-3.118
			C2432.031,1506.613,2433.429,1508.012,2433.429,1509.731z"
          />
          <rect
            x="2429.5"
            y="1470.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="11"
          />

          <rect
            x="2418.462"
            y="1474.954"
            transform="matrix(0.866 -0.5001 0.5001 0.866 -415.2622 1408.0756)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.682"
          />

          <rect
            x="2410.494"
            y="1482.921"
            transform="matrix(0.5008 -0.8655 0.8655 0.5008 -83.144 2829.355)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.683"
          />

          <rect
            x="2447.98"
            y="1482.864"
            transform="matrix(0.5006 0.8657 -0.8657 0.5006 2509.958 -1377.5371)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="2440.012"
            y="1475.011"
            transform="matrix(0.8659 0.5002 -0.5002 0.8659 1067.134 -1022.7314)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.682"
          />
          <rect
            x="2429.5"
            y="1470.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="4"
            height="11"
          />
          <polygon
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            points="2429.639,1494.574 2428.072,1495.377
			2422.184,1483.824 2423.753,1483.022 		"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M2434.143,1497.43c-0.09,0-1.771-3.683-3.834-3.683
			c-2.071,0-3.748,3.683-3.834,3.683H2434.143z"
          />
        </g>
        <g id="M10283">
          <text
            id="C10283"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 2424.3506 1694.3389)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >备用</text>
          <path
            id="B10283"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M2464.5,1675.637
			c0,3.174-2.5,4.793-5.718,4.793h-54.853c-3.223,0-8.43-1.619-8.43-4.793v-52.626c0-3.167,5.207-7.581,8.43-7.581h54.853
			c3.218,0,5.718,4.414,5.718,7.581V1675.637z"
          />

          <rect
            id="A10283"
            x="2399.5"
            y="1621.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="61"
            height="33"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M2434.596,1666.731
			c0,1.728-1.396,3.125-3.118,3.125c-1.727,0-3.124-1.397-3.124-3.125c0-1.72,1.397-3.118,3.124-3.118
			C2433.199,1663.613,2434.596,1665.012,2434.596,1666.731z"
          />
          <rect
            x="2431.5"
            y="1628.289"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="0"
            height="9.779"
          />

          <rect
            x="2419.63"
            y="1631.954"
            transform="matrix(0.866 -0.5001 0.5001 0.866 -493.6177 1429.7007)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.682"
          />

          <rect
            x="2411.663"
            y="1639.922"
            transform="matrix(0.5008 -0.8655 0.8655 0.5008 -218.4512 2908.7349)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.682"
          />

          <rect
            x="2449.148"
            y="1639.864"
            transform="matrix(0.5006 0.8657 -0.8657 0.5006 2646.4517 -1300.1445)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="2441.181"
            y="1632.011"
            transform="matrix(0.8658 0.5005 -0.5005 0.8658 1146.4983 -1002.5901)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.682"
          />
          <rect
            x="2431.5"
            y="1628.289"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="0"
            height="9.779"
          />
          <polygon
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            points="2430.808,1651.574 2429.241,1652.377
			2423.353,1640.824 2424.922,1640.022 		"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M2435.312,1654.43c-0.091,0-1.771-3.683-3.834-3.683
			c-2.072,0-3.748,3.683-3.834,3.683H2435.312z"
          />
        </g>
        <g id="M10284">
          <text
            id="C10284"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 2421.5195 1839.3379)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >备用</text>
          <path
            id="B10284"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M2462.5,1820.637
			c0,3.174-3.332,4.793-6.549,4.793h-54.854c-3.222,0-7.597-1.619-7.597-4.793v-52.626c0-3.167,4.375-7.581,7.597-7.581h54.854
			c3.217,0,6.549,4.414,6.549,7.581V1820.637z"
          />

          <rect
            id="A10284"
            x="2397.5"
            y="1766.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="58"
            height="33"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M2431.764,1811.731
			c0,1.728-1.396,3.125-3.119,3.125c-1.725,0-3.123-1.397-3.123-3.125c0-1.72,1.398-3.118,3.123-3.118
			C2430.367,1808.613,2431.764,1810.012,2431.764,1811.731z"
          />
          <rect
            x="2426.5"
            y="1772.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="11"
          />

          <rect
            x="2416.797"
            y="1776.953"
            transform="matrix(0.866 -0.5001 0.5001 0.866 -566.5078 1447.7164)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.683"
          />

          <rect
            x="2408.831"
            y="1784.922"
            transform="matrix(0.5008 -0.8655 0.8655 0.5008 -345.3682 2978.6624)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.682"
          />

          <rect
            x="2446.315"
            y="1784.864"
            transform="matrix(0.5002 0.8659 -0.8659 0.5002 2771.8838 -1225.1394)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="2438.349"
            y="1777.011"
            transform="matrix(0.8658 0.5005 -0.5005 0.8658 1218.6841 -981.708)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.682"
          />
          <rect
            x="2426.5"
            y="1772.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="11"
          />
          <polygon
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            points="2427.977,1796.574 2426.41,1797.377
			2420.521,1785.824 2422.09,1785.022 		"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M2432.48,1799.43c-0.091,0-1.771-3.683-3.836-3.683
			c-2.07,0-3.747,3.683-3.834,3.683H2432.48z"
          />
        </g>
        <g id="M10286">
          <text
            id="C10286"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 2418.1543 2129.375)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >真空泵房</text>
          <path
            id="B10286"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M2466.5,2110.678
			c0,3.172-3.332,2.752-6.549,2.752h-54.854c-3.222,0-7.597,0.42-7.597-2.752v-52.625c0-3.169,4.375-6.623,7.597-6.623h54.854
			c3.217,0,6.549,3.454,6.549,6.623V2110.678z"
          />

          <rect
            id="A10286"
            x="2401.5"
            y="2055.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="58"
            height="33"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M2435.764,2101.772
			c0,1.726-1.396,3.123-3.119,3.123c-1.725,0-3.123-1.397-3.123-3.123c0-1.722,1.398-3.119,3.123-3.119
			C2434.367,2098.653,2435.764,2100.051,2435.764,2101.772z"
          />
          <rect
            x="2430.5"
            y="2064.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="7"
          />

          <rect
            x="2420.797"
            y="2066.993"
            transform="matrix(0.8655 -0.5008 0.5008 0.8655 -711.5244 1491.3435)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.685"
          />

          <rect
            x="2412.83"
            y="2074.961"
            transform="matrix(0.5006 -0.8657 0.8657 0.5006 -594.1465 3127.667)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.682"
          />

          <rect
            x="2450.315"
            y="2074.904"
            transform="matrix(0.5002 0.8659 -0.8659 0.5002 3025.0256 -1083.6514)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="2442.349"
            y="2067.051"
            transform="matrix(0.8658 0.5005 -0.5005 0.8658 1364.3735 -944.7754)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.922"
            height="7.684"
          />
          <rect
            x="2430.5"
            y="2064.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="7"
          />
          <polygon
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            points="2431.977,2086.614 2430.41,2087.416
			2424.521,2075.864 2426.09,2075.063 		"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M2436.48,2091.43c-0.091-3-1.771-3.683-3.836-3.683
			c-2.07,0-3.747,0.683-3.834,3.683H2436.48z"
          />
        </g>
        <g id="M10287">
          <text
            id="C10287"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 2407.2754 2281.373)"
            style="font-family:'MicrosoftYaHei'; font-size:10.521px;"
          >冷冻机组循环泵</text>
          <path
            id="B10287"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M2463.5,2262.678
			c0,3.172-0.162,2.752-3.381,2.752h-54.854c-3.222,0-6.766,0.42-6.766-2.752v-52.625c0-3.169,3.544-6.623,6.766-6.623h54.854
			c3.219,0,3.381,3.454,3.381,6.623V2262.678z"
          />

          <rect
            id="A10287"
            x="2402.5"
            y="2207.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="58"
            height="33"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M2435.933,2253.772
			c0,1.726-1.397,3.123-3.12,3.123c-1.725,0-3.122-1.397-3.122-3.123c0-1.722,1.397-3.119,3.122-3.119
			C2434.535,2250.653,2435.933,2252.051,2435.933,2253.772z"
          />
          <rect
            x="2431.5"
            y="2216.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="2"
            height="7"
          />

          <rect
            x="2420.965"
            y="2218.993"
            transform="matrix(0.8655 -0.5008 0.5008 0.8655 -787.6289 1511.8655)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="2412.998"
            y="2226.96"
            transform="matrix(0.5002 -0.8659 0.8659 0.5002 -725.2163 3205.0984)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />

          <rect
            x="2450.484"
            y="2226.904"
            transform="matrix(0.5002 0.8659 -0.8659 0.5002 3156.7251 -1007.8328)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.683"
          />

          <rect
            x="2442.517"
            y="2219.051"
            transform="matrix(0.8659 0.5002 -0.5002 0.8659 1439.6655 -924.2007)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.923"
            height="7.684"
          />
          <rect
            x="2431.5"
            y="2216.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="2"
            height="7"
          />
          <polygon
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            points="2432.143,2238.614 2430.578,2239.416
			2424.688,2227.864 2426.259,2227.063 		"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M2436.646,2243.43c-0.089-3-1.771-3.683-3.834-3.683
			c-2.07,0-3.748,0.683-3.834,3.683H2436.646z"
          />
        </g>
        <g id="M10261">
          <text
            id="C10261"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 2707.1328 1452.1846)"
            style="font-family:'MicrosoftYaHei'; font-size:9.2059px;"
          >HT101注塑机1400T</text>
          <path
            id="B10261"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M2760.5,1435.822
			c0,2.772-2.133,3.607-4.948,3.607h-47.995c-2.82,0-6.057-0.835-6.057-3.607v-46.051c0-2.771,3.236-8.342,6.057-8.342h47.995
			c2.815,0,4.948,5.57,4.948,8.342V1435.822z"
          />

          <rect
            id="A10261"
            x="2704.5"
            y="1387.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="52"
            height="29"
          />
          <path
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            d="M2734.389,1428.029
			c0,1.51-1.223,2.729-2.729,2.729c-1.51,0-2.732-1.219-2.732-2.729c0-1.508,1.223-2.734,2.732-2.734
			C2733.166,1425.295,2734.389,1426.521,2734.389,1428.029z"
          />
          <rect
            x="2730.5"
            y="1394.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="6"
          />

          <rect
            x="2721.293"
            y="1397.595"
            transform="matrix(0.8655 -0.5009 0.5009 0.8655 -335.6189 1552.0968)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.682"
            height="6.726"
          />

          <rect
            x="2714.322"
            y="1404.567"
            transform="matrix(0.4999 -0.8661 0.8661 0.4999 138.4873 3055.6904)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.68"
            height="6.725"
          />

          <rect
            x="2747.123"
            y="1404.517"
            transform="matrix(0.5005 0.8657 -0.8657 0.5005 2591.4258 -1675.7751)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.682"
            height="6.725"
          />
          <polygon
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            points="2740.041,1404.34 2738.582,1403.498
			2741.945,1397.675 2743.396,1398.518 		"
          />
          <rect
            x="2730.5"
            y="1394.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="6"
          />
          <polygon
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            points="2731.075,1414.762 2729.704,1415.465
			2724.551,1405.36 2725.924,1404.656 		"
          />
          <path
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            d="M2735.016,1416.43c-0.08,0-1.552-3.221-3.355-3.221
			c-1.813,0-3.28,3.221-3.355,3.221H2735.016z"
          />
        </g>
        <g id="M10262">
          <text
            id="C10262"
            transform="matrix(0.7 1.960000e-004 -2.799999e-004 1 2709.1348 1589.0508)"
            style="font-family:'MicrosoftYaHei'; font-size:8.9002px;"
          >HT102注塑机1400T</text>
          <path
            id="B10262"
            style="fill: #29ABE2; stroke: #29ABE2;stroke-miterlimit: 10;"
            d="M2760.5,1573.235
			c0,2.683-1.831,4.194-4.554,4.194h-46.401c-2.727,0-7.045-1.512-7.045-4.194v-44.522c0-2.68,4.318-6.283,7.045-6.283h46.401
			c2.723,0,4.554,3.604,4.554,6.283V1573.235z"
          />

          <rect
            id="A10262"
            x="2709.5"
            y="1528.43"
            style="fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="49"
            height="29"
          />
          <circle
            style="fill:#FF0000;stroke:#FF0000;stroke-width:3.6328;stroke-miterlimit:10;"
            cx="2732.846"
            cy="1565.7"
            r="2.641"
          />
          <rect
            x="2731.5"
            y="1531.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="10"
          />

          <rect
            x="2722.824"
            y="1536.279"
            transform="matrix(0.8656 -0.5007 0.5007 0.8656 -404.8438 1570.4528)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.627"
            height="6.501"
          />

          <rect
            x="2716.085"
            y="1543.02"
            transform="matrix(0.5 -0.866 0.866 0.5 19.3088 3125.9839)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.625"
            height="6.499"
          />

          <rect
            x="2747.797"
            y="1542.97"
            transform="matrix(0.5002 0.8659 -0.8659 0.5002 2712.6152 -1607.2471)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.626"
            height="6.5"
          />

          <rect
            x="2741.056"
            y="1536.329"
            transform="matrix(0.8658 0.5004 -0.5004 0.8658 1138.3711 -1165.4072)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.628"
            height="6.497"
          />
          <rect
            x="2731.5"
            y="1531.43"
            style="stroke:#000000;stroke-width:3;stroke-miterlimit:10;"
            width="3"
            height="10"
          />

          <rect
            x="2728.384"
            y="1542.846"
            transform="matrix(0.8902 -0.4556 0.4556 0.8902 -405.7188 1413.41)"
            style="stroke:#000000;stroke-width:4.2084;stroke-miterlimit:10;"
            width="1.488"
            height="10.97"
          />
          <path
            style="stroke:#000000;stroke-width:4;stroke-miterlimit:10;"
            d="M2736.092,1555.93c-0.076-1-1.498-3.115-3.245-3.115
			c-1.751,0-3.169,2.115-3.242,3.115H2736.092z"
          />
        </g>
        <g id="M40005">
          <text
            id="C40005"
            x="0"
            y="0"
            font-family="'MicrosoftYaHei'"
            transform="matrix(0.6999999999999998,0.00019599999999999997,-0.00027999989999999994,0.9999999999999999,1900.0547093749994,264.3912806640626) "
          >一期配变</text>
          <path
            id="B40005"
            fill=" #29ABE2"
            stroke-miterlimit="10"
            d="m1949.53711,245.69518c0,3.172 -3.64,1.92 -6.856,1.92l-54.854,0c-3.222,0 -7.29,1.252 -7.29,-1.92l0,-52.626c0,-3.169 4.068,-5.454 7.29,-5.454l54.854,0c3.216,0 6.856,2.285 6.856,5.454l0,52.626z"
          />
          <rect
            fill="#FFFFFF"
            stroke="#000000"
            stroke-width="3"
            stroke-miterlimit="10"
            height="36"
            width="58"
            y="189.61518"
            x="1884.53711"
            id="A40005"
          />
          <path
            fill="#FF0000"
            stroke="#FF0000"
            stroke-width="3.6328"
            stroke-miterlimit="10"
            d="m1918.49511,236.78918c0,1.726 -1.397,3.123 -3.12,3.123c-1.727,0 -3.125,-1.397 -3.125,-3.123c0,-1.722 1.397,-3.12 3.125,-3.12c1.722,0 3.12,1.399 3.12,3.12z"
          />
          <rect
            stroke="#000000"
            stroke-width="3"
            stroke-miterlimit="10"
            height="7"
            width="3"
            y="198.61518"
            x="1913.53711"
          />
          <rect
            stroke="#000000"
            stroke-width="4.2084"
            stroke-miterlimit="10"
            height="7.684"
            width="1.922"
            transform="matrix(0.8661,-0.4999,0.4999,0.8661,-801.0665,250.7079) "
            y="1309.79771"
            x="2364.74661"
          />
          <rect
            stroke="#000000"
            stroke-width="4.2084"
            stroke-miterlimit="10"
            height="7.684"
            width="1.922"
            transform="matrix(0.5005,-0.8658,0.8658,0.5005,-1380.2947,865.0746) "
            y="2507.08696"
            x="2202.67112"
          />
          <rect
            stroke="#000000"
            stroke-width="4.2084"
            stroke-miterlimit="10"
            height="7.682"
            width="1.922"
            transform="matrix(0.4999,0.8661,-0.8661,0.4999,1459.0245,730.5392) "
            y="-673.52161"
            x="-211.01929"
          />
          <rect
            stroke="#000000"
            stroke-width="4.2084"
            stroke-miterlimit="10"
            height="7.685"
            width="1.923"
            transform="matrix(0.8659,0.5002,-0.5002,0.8659,822.6795,172.8339) "
            y="-527.12888"
            x="971.0562"
          />
          <rect
            stroke="#000000"
            stroke-width="3"
            stroke-miterlimit="10"
            height="7"
            width="3"
            y="198.61518"
            x="1913.53711"
          />
          <polygon
            stroke="#000000"
            stroke-width="4.2084"
            stroke-miterlimit="10"
            points="1914.7051086425781,221.630126953125 1913.1391067504883,222.4332275390625 1907.2491073608398,210.880126953125 1908.819107055664,210.0792236328125 "
          />
          <path
            stroke="#000000"
            stroke-width="3"
            stroke-miterlimit="10"
            d="m1919.20911,225.61518c-0.09,-3 -1.771,-3.684 -3.834,-3.684c-2.073,0 -3.748,0.684 -3.834,3.684l7.668,0z"
          />
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'OneSVG'
};
</script>

<style lang="less" scope>
#OneSVG {
  position: relative;
  width: 60%;
  height: 100%;
  background-color: rgba(6, 30, 93, 0.5);
  // border-top: 2px solid rgba(1, 153, 209, 0.5);
  box-sizing: border-box;
}
</style>
